var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeedbackParking(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M441.72,160.48s-16.87-67.66-119-110.33S129.22,47,108.39,97s1,77-12.9,119.7S10.18,313.48,39,379.06s163.68,84.31,272.81,70.78S506.2,286.42,441.72,160.48Z",
    style: {
      fill: "#DE0EEA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.72,160.48s-16.87-67.66-119-110.33S129.22,47,108.39,97s1,77-12.9,119.7S10.18,313.48,39,379.06s163.68,84.31,272.81,70.78S506.2,286.42,441.72,160.48Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53,415.57a.49.49,0,0,1-.49-.45l-14.19-136a.5.5,0,0,1,.44-.55.5.5,0,0,1,.55.45L53.46,415a.49.49,0,0,1-.44.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.17,389a.46.46,0,0,1-.36-.16l-5.93-6.22a.5.5,0,1,1,.73-.69l5.92,6.22a.5.5,0,0,1,0,.71A.49.49,0,0,1,50.17,389Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2,384.29a7.31,7.31,0,0,0-2.56-5.46c-1.65-1.47-10.34-5.13-11.17-2.07C31.58,380.09,40.47,386.63,46.2,384.29Z",
    style: {
      fill: "#DE0EEA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.55,385.27a14.66,14.66,0,0,1-9-3.72c-2-1.75-2.9-3.54-2.53-4.92a2,2,0,0,1,1.45-1.4c2.84-.84,9.07,1.92,10.53,3.23a7.74,7.74,0,0,1,2.73,5.86l0,.31-.29.12A7.5,7.5,0,0,1,43.55,385.27Zm-8.86-9.2a3.45,3.45,0,0,0-1,.12,1,1,0,0,0-.77.7c-.26,1,.59,2.46,2.23,3.91,2.77,2.45,7.21,4.26,10.51,3.14a6.93,6.93,0,0,0-2.39-4.74C42.15,378.18,37.4,376.07,34.69,376.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2,384.79a.56.56,0,0,1-.27-.08l-8.27-5.15a.51.51,0,0,1-.16-.69.49.49,0,0,1,.69-.16l8.27,5.15a.5.5,0,0,1-.26.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.64,403a.48.48,0,0,1-.32-.11l-5.78-4.81a.5.5,0,0,1-.07-.7.5.5,0,0,1,.71-.07L52,402.14a.49.49,0,0,1,.06.7A.48.48,0,0,1,51.64,403Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.81,399.75a7.27,7.27,0,0,0-2.56-5.46c-1.65-1.47-10.34-5.13-11.16-2.07C33.19,395.55,42.08,402.09,47.81,399.75Z",
    style: {
      fill: "#DE0EEA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.17,400.74a14.68,14.68,0,0,1-9-3.73c-2-1.75-2.91-3.54-2.54-4.92a2,2,0,0,1,1.46-1.39c2.83-.84,9.06,1.91,10.53,3.22a7.72,7.72,0,0,1,2.72,5.86l0,.31-.29.12A7.46,7.46,0,0,1,45.17,400.74Zm-8.87-9.2a3.52,3.52,0,0,0-1,.11,1,1,0,0,0-.77.7c-.26,1,.59,2.47,2.23,3.91,2.78,2.45,7.22,4.26,10.51,3.14a6.9,6.9,0,0,0-2.39-4.73C43.77,393.64,39,391.54,36.3,391.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.81,400.25a.42.42,0,0,1-.26-.08L39.28,395a.5.5,0,0,1,.52-.85l8.28,5.16a.5.5,0,0,1-.27.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.15,350.27a.54.54,0,0,1-.34-.12L40,344.89a.5.5,0,0,1,0-.71.49.49,0,0,1,.7,0l5.84,5.25a.5.5,0,0,1,0,.71A.49.49,0,0,1,46.15,350.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.26,346.55a7.25,7.25,0,0,0-2.56-5.45C38.05,339.62,29.36,336,28.54,339,27.64,342.36,36.53,348.89,42.26,346.55Z",
    style: {
      fill: "#DE0EEA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.61,347.54a14.59,14.59,0,0,1-9-3.73c-2-1.74-2.91-3.54-2.54-4.91a2,2,0,0,1,1.46-1.4c2.83-.84,9.06,1.92,10.52,3.22a7.72,7.72,0,0,1,2.73,5.86l0,.32-.29.12A7.46,7.46,0,0,1,39.61,347.54Zm-8.86-9.2a3.45,3.45,0,0,0-1,.12,1,1,0,0,0-.77.7c-.26,1,.59,2.46,2.23,3.9,2.78,2.46,7.21,4.27,10.51,3.15a6.93,6.93,0,0,0-2.39-4.74C38.22,340.44,33.46,338.34,30.75,338.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.26,347.05A.48.48,0,0,1,42,347l-8.28-5.16a.5.5,0,0,1,.53-.85l8.28,5.16a.5.5,0,0,1-.27.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.78,366.72a.52.52,0,0,1-.37-.16l-5.85-6.24a.5.5,0,1,1,.72-.68l5.86,6.23a.5.5,0,0,1,0,.71A.51.51,0,0,1,47.78,366.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.87,362a7.26,7.26,0,0,0-2.56-5.46c-1.65-1.47-10.34-5.13-11.16-2.07C29.25,357.82,38.15,364.36,43.87,362Z",
    style: {
      fill: "#DE0EEA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.23,363a14.66,14.66,0,0,1-9-3.72c-2-1.75-2.9-3.54-2.53-4.92a2,2,0,0,1,1.45-1.4c2.83-.84,9.07,1.92,10.53,3.23a7.72,7.72,0,0,1,2.72,5.86l0,.31-.29.12A7.45,7.45,0,0,1,41.23,363Zm-8.87-9.2a3.5,3.5,0,0,0-1,.12,1,1,0,0,0-.77.7c-.26,1,.6,2.46,2.23,3.91,2.78,2.45,7.22,4.26,10.51,3.14A6.89,6.89,0,0,0,41,356.93C39.83,355.91,35.07,353.8,32.36,353.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.87,362.52a.5.5,0,0,1-.26-.08l-8.27-5.15a.5.5,0,0,1,.53-.85l8.27,5.15a.5.5,0,0,1,.16.69A.52.52,0,0,1,43.87,362.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.54,325.87a.5.5,0,0,1-.35-.15l-5.86-6a.5.5,0,1,1,.71-.7l5.86,6a.5.5,0,0,1,0,.71A.54.54,0,0,1,43.54,325.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.64,321.44A7.31,7.31,0,0,0,37.08,316c-1.65-1.48-10.34-5.13-11.17-2.07C25,317.24,33.91,323.78,39.64,321.44Z",
    style: {
      fill: "#DE0EEA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37,322.42a14.61,14.61,0,0,1-9-3.72c-2-1.75-2.91-3.54-2.54-4.92a2,2,0,0,1,1.45-1.4c2.83-.85,9.07,1.92,10.53,3.23a7.74,7.74,0,0,1,2.73,5.86l0,.31-.29.12A7.46,7.46,0,0,1,37,322.42Zm-8.86-9.2a3.45,3.45,0,0,0-1,.12,1,1,0,0,0-.77.7c-.26,1,.59,2.46,2.23,3.91,2.77,2.45,7.21,4.26,10.51,3.14a6.93,6.93,0,0,0-2.39-4.74C35.6,315.32,30.84,313.22,28.13,313.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.64,321.94a.5.5,0,0,1-.26-.08l-8.28-5.15a.51.51,0,0,1-.16-.69.49.49,0,0,1,.69-.16L39.9,321a.5.5,0,0,1-.26.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.72,299a.49.49,0,0,1-.3-.1l-5.67-4.34a.5.5,0,0,1-.09-.7.51.51,0,0,1,.7-.1L41,298.11a.5.5,0,0,1,.09.7A.51.51,0,0,1,40.72,299Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37,296.21a7.31,7.31,0,0,0-2.56-5.46c-1.65-1.47-10.34-5.13-11.17-2.07C22.38,292,31.28,298.55,37,296.21Z",
    style: {
      fill: "#DE0EEA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.36,297.19a14.66,14.66,0,0,1-9-3.72c-2-1.75-2.9-3.54-2.53-4.92a2,2,0,0,1,1.45-1.4c2.83-.84,9.07,1.92,10.53,3.23a7.79,7.79,0,0,1,2.73,5.86l0,.31-.29.12A7.54,7.54,0,0,1,34.36,297.19ZM25.49,288a3.38,3.38,0,0,0-.95.12,1,1,0,0,0-.78.7c-.26,1,.6,2.46,2.23,3.91,2.78,2.45,7.22,4.26,10.51,3.14a6.89,6.89,0,0,0-2.39-4.74C33,290.1,28.2,288,25.49,288Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37,296.71a.53.53,0,0,1-.27-.08l-8.27-5.15a.5.5,0,0,1,.53-.85l8.27,5.15a.49.49,0,0,1,.16.69A.5.5,0,0,1,37,296.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6,380.4a.56.56,0,0,1-.27-.08.51.51,0,0,1-.16-.69l4.89-8a.5.5,0,0,1,.85.52l-4.89,8A.5.5,0,0,1,49.6,380.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53,374.32a7.26,7.26,0,0,1,1.37-5.87c1.31-1.79,9.06-7.16,10.5-4.33C66.44,367.19,59.08,375.42,53,374.32Z",
    style: {
      fill: "#DE0EEA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.12,374.91a6.89,6.89,0,0,1-1.21-.1l-.31-.06-.09-.3a7.76,7.76,0,0,1,1.46-6.3c1.16-1.58,6.69-5.56,9.64-5.33a2,2,0,0,1,1.71,1.07c.64,1.27.11,3.22-1.47,5.34C61.64,372.2,57.73,374.91,54.12,374.91Zm-.7-1c3.45.42,7.42-2.27,9.63-5.24,1.3-1.75,1.83-3.39,1.38-4.29a1,1,0,0,0-.9-.52c-2.46-.2-7.72,3.52-8.75,4.92A6.85,6.85,0,0,0,53.42,373.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53,374.82a.52.52,0,0,1-.37-.16.5.5,0,0,1,0-.71l5.82-5.46a.5.5,0,1,1,.69.73l-5.82,5.46A.51.51,0,0,1,53,374.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.35,339.71a.5.5,0,0,1-.26-.08.5.5,0,0,1-.17-.69l4.89-8a.5.5,0,0,1,.86.52l-4.89,8A.52.52,0,0,1,45.35,339.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.75,333.62a7.27,7.27,0,0,1,1.38-5.86c1.31-1.79,7.37-6.25,8.81-3.43C60.5,327.4,54.84,334.73,48.75,333.62Z",
    style: {
      fill: "#DE0EEA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,334.24a7.9,7.9,0,0,1-1.36-.12l-.31-.06-.08-.3a7.73,7.73,0,0,1,1.45-6.3c1.07-1.45,5.24-4.76,7.86-4.53a2.09,2.09,0,0,1,1.8,1.17c.72,1.41.19,3.58-1.36,5.68S53.44,334.24,50,334.24Zm-.85-1.06c3.39.44,6.44-1.85,8-4,1.31-1.76,1.82-3.58,1.28-4.62a1.1,1.1,0,0,0-1-.64c-2.09-.17-6,2.85-7,4.13A6.89,6.89,0,0,0,49.17,333.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.75,334.12a.5.5,0,0,1-.35-.86l7.45-7.12a.5.5,0,0,1,.69.73L49.09,334A.48.48,0,0,1,48.75,334.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.48,321.82a.48.48,0,0,1-.26-.07.5.5,0,0,1-.16-.69l4.89-8a.5.5,0,0,1,.85.53l-4.89,8A.49.49,0,0,1,43.48,321.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.88,315.74a7.29,7.29,0,0,1,1.38-5.87c1.31-1.78,9.06-7.15,10.5-4.33C60.32,308.62,53,316.85,46.88,315.74Z",
    style: {
      fill: "#DE0EEA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,316.34a6.12,6.12,0,0,1-1.21-.11l-.31-.05-.08-.3a7.76,7.76,0,0,1,1.46-6.3C49,308,54.54,304,57.49,304.25a2,2,0,0,1,1.71,1.07c.65,1.27.12,3.21-1.46,5.33C55.52,313.63,51.62,316.34,48,316.34Zm-.7-1c3.46.42,7.43-2.27,9.64-5.25,1.3-1.75,1.83-3.39,1.37-4.28a1,1,0,0,0-.9-.52c-2.45-.2-7.71,3.51-8.75,4.92A6.94,6.94,0,0,0,47.3,315.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.88,316.24a.5.5,0,0,1-.34-.86L54,308.26a.5.5,0,0,1,.69.72l-7.45,7.12A.47.47,0,0,1,46.88,316.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.75,295.61a.5.5,0,0,1-.26-.08.5.5,0,0,1-.17-.69l4.89-8a.49.49,0,0,1,.69-.16.48.48,0,0,1,.16.68l-4.89,8A.5.5,0,0,1,40.75,295.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.15,289.53a7.29,7.29,0,0,1,1.38-5.87c1.31-1.79,9-7.16,10.49-4.33C57.59,282.4,50.23,290.63,44.15,289.53Z",
    style: {
      fill: "#DE0EEA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.27,290.12a6.89,6.89,0,0,1-1.21-.1l-.31-.06-.09-.3a7.8,7.8,0,0,1,1.46-6.3c1.16-1.58,6.68-5.57,9.64-5.33a2,2,0,0,1,1.71,1.07c.64,1.27.11,3.21-1.47,5.33C52.79,287.41,48.89,290.12,45.27,290.12Zm-.7-1c3.44.43,7.42-2.27,9.63-5.24,1.3-1.75,1.83-3.39,1.38-4.29a1,1,0,0,0-.9-.52c-2.45-.18-7.72,3.52-8.75,4.92A6.85,6.85,0,0,0,44.57,289.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.15,290a.5.5,0,0,1-.35-.86L51.25,282a.5.5,0,0,1,.69.73l-7.45,7.12A.49.49,0,0,1,44.15,290Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.66,278.35A7.26,7.26,0,0,1,40,272.48c1.31-1.79,9.06-7.16,10.5-4.33C52.1,271.22,44.74,279.45,38.66,278.35Z",
    style: {
      fill: "#DE0EEA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.78,278.94a6.89,6.89,0,0,1-1.21-.1l-.31-.06-.09-.3a7.76,7.76,0,0,1,1.46-6.3c1.16-1.58,6.7-5.57,9.64-5.33A2,2,0,0,1,51,267.92c.64,1.27.11,3.21-1.47,5.33C47.3,276.23,43.39,278.94,39.78,278.94Zm-.7-1c3.44.43,7.42-2.27,9.63-5.24,1.3-1.75,1.83-3.39,1.38-4.29a1,1,0,0,0-.91-.52c-2.42-.19-7.71,3.52-8.74,4.92A6.85,6.85,0,0,0,39.08,277.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.66,278.85a.52.52,0,0,1-.37-.16.5.5,0,0,1,0-.71l7.45-7.12a.5.5,0,1,1,.69.73L39,278.71A.51.51,0,0,1,38.66,278.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.09,278.65a7.3,7.3,0,0,1-5.69-2c-1.64-1.49-6.17-9.76-3.21-10.9C33.41,264.54,40.83,272.71,39.09,278.65Z",
    style: {
      fill: "#DE0EEA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.43,279.19A7.94,7.94,0,0,1,33.06,277c-1.45-1.32-4.84-7.24-4.29-10.14A2,2,0,0,1,30,265.31c1.33-.52,3.21.22,5.15,2,3,2.8,5.53,7.64,4.41,11.47l-.09.3-.31.06A7.35,7.35,0,0,1,38.43,279.19Zm-7.52-13a1.53,1.53,0,0,0-.54.09,1,1,0,0,0-.62.84c-.45,2.4,2.69,8,4,9.22a6.94,6.94,0,0,0,5,1.89c.78-3.39-1.48-7.62-4.2-10.13A6.09,6.09,0,0,0,30.91,266.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.09,279.15a.5.5,0,0,1-.4-.19l-6.3-8.16a.5.5,0,0,1,.79-.61l6.3,8.16a.49.49,0,0,1-.39.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,414.9a.5.5,0,0,1-.5-.5V242.46a.5.5,0,0,1,1,0V414.4A.5.5,0,0,1,60,414.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.09,434.3H62a.5.5,0,0,1-.45-.55l14.11-136a.49.49,0,0,1,.55-.44.5.5,0,0,1,.45.55l-14.11,136A.51.51,0,0,1,62.09,434.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.07,406.52a.52.52,0,0,1-.38-.17l-3.26-3.73a.51.51,0,0,1,0-.71.49.49,0,0,1,.7,0l3.27,3.73a.51.51,0,0,1,0,.71A.5.5,0,0,1,65.07,406.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.81,402.29a7.29,7.29,0,0,0-1.38-5.87c-1.32-1.78-9.07-7.15-10.5-4.32C48.36,395.17,55.72,403.4,61.81,402.29Z",
    style: {
      fill: "#DE0EEA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.68,402.89c-3.61,0-7.51-2.71-9.73-5.69-1.58-2.12-2.12-4.06-1.47-5.33a2,2,0,0,1,1.71-1.07c2.94-.23,8.48,3.74,9.64,5.32a7.76,7.76,0,0,1,1.46,6.3l-.08.3-.31.06A7.1,7.1,0,0,1,60.68,402.89Zm-9.21-11.1h-.2a1,1,0,0,0-.9.52c-.45.89.08,2.54,1.38,4.29,2.21,3,6.18,5.66,9.64,5.24A6.9,6.9,0,0,0,60,396.72C59,395.35,54,391.79,51.47,391.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.81,402.79a.52.52,0,0,1-.35-.14l-7-6.75a.5.5,0,1,1,.69-.72l7,6.75a.49.49,0,0,1,0,.7A.48.48,0,0,1,61.81,402.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.06,367.7a.47.47,0,0,1-.32-.12l-4.85-4.05a.5.5,0,1,1,.64-.76l4.85,4a.51.51,0,0,1,.06.71A.49.49,0,0,1,69.06,367.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.72,364.55a7.29,7.29,0,0,0-1.38-5.87c-1.31-1.78-9.06-7.15-10.5-4.32C52.28,357.43,59.64,365.66,65.72,364.55Z",
    style: {
      fill: "#DE0EEA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6,365.15c-3.62,0-7.52-2.71-9.74-5.68-1.58-2.12-2.11-4.07-1.46-5.34a2,2,0,0,1,1.71-1.07c2.94-.23,8.47,3.75,9.63,5.33a7.77,7.77,0,0,1,1.47,6.29l-.09.31-.31.05A6.12,6.12,0,0,1,64.6,365.15Zm-9.22-11.1h-.19a1,1,0,0,0-.9.53c-.46.89.07,2.53,1.37,4.28,2.22,3,6.19,5.66,9.64,5.24A6.89,6.89,0,0,0,63.94,359C62.93,357.61,57.89,354.05,55.38,354.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.72,365.05a.45.45,0,0,1-.34-.14l-7-6.75a.49.49,0,0,1,0-.7.5.5,0,0,1,.71,0l7,6.75a.5.5,0,0,1,0,.71A.49.49,0,0,1,65.72,365.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.52,386.09a.51.51,0,0,1-.43-.23l-4.89-8a.5.5,0,0,1,.85-.52l4.9,8a.5.5,0,0,1-.17.69A.48.48,0,0,1,67.52,386.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.12,380a7.29,7.29,0,0,0-1.38-5.87c-1.32-1.78-9.07-7.15-10.5-4.33C50.67,372.9,58,381.13,64.12,380Z",
    style: {
      fill: "#DE0EEA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63,380.62c-3.61,0-7.51-2.71-9.73-5.69-1.58-2.12-2.12-4.06-1.47-5.33a2,2,0,0,1,1.71-1.07c2.93-.24,8.48,3.74,9.64,5.32a7.72,7.72,0,0,1,1.46,6.3l-.08.3-.31.06A7.1,7.1,0,0,1,63,380.62Zm-9.21-11.1h-.2a1,1,0,0,0-.9.52c-.45.89.08,2.53,1.38,4.28,2.21,3,6.19,5.66,9.64,5.24a6.92,6.92,0,0,0-1.37-5.13C61.32,373.07,56.29,369.52,53.78,369.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.12,380.52a.52.52,0,0,1-.35-.14l-7-6.75a.5.5,0,0,1,0-.71.5.5,0,0,1,.71,0l7,6.75a.49.49,0,0,1,0,.7A.52.52,0,0,1,64.12,380.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.51,342.92a.52.52,0,0,1-.38-.17l-4.67-5.39a.5.5,0,0,1,.75-.65l4.68,5.38a.51.51,0,0,1,0,.71A.52.52,0,0,1,71.51,342.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.33,339.43A7.29,7.29,0,0,0,67,333.56c-1.31-1.78-9.07-7.15-10.5-4.32C54.88,332.31,62.24,340.54,68.33,339.43Z",
    style: {
      fill: "#DE0EEA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.21,340c-3.62,0-7.52-2.71-9.74-5.68-1.58-2.12-2.11-4.07-1.47-5.34a2,2,0,0,1,1.71-1.07c2.94-.23,8.48,3.75,9.64,5.33a7.7,7.7,0,0,1,1.46,6.29l-.08.31-.31.05A6.19,6.19,0,0,1,67.21,340ZM58,328.93h-.2a1,1,0,0,0-.9.53c-.45.89.08,2.53,1.38,4.28,2.22,3,6.2,5.66,9.64,5.24a6.92,6.92,0,0,0-1.37-5.13C65.54,332.49,60.5,328.93,58,328.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.33,339.93a.54.54,0,0,1-.35-.14L61,333a.48.48,0,0,1,0-.7.49.49,0,0,1,.7,0l7,6.75a.5.5,0,0,1-.35.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,319.31a.51.51,0,0,1-.42-.23l-4.51-7a.5.5,0,0,1,.85-.54l4.5,7a.49.49,0,0,1-.15.69A.43.43,0,0,1,74,319.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71,314.2a7.29,7.29,0,0,0-1.38-5.87c-1.32-1.78-9.07-7.15-10.5-4.32C57.5,307.08,64.86,315.31,71,314.2Z",
    style: {
      fill: "#DE0EEA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.82,314.8c-3.61,0-7.51-2.71-9.73-5.68-1.58-2.12-2.12-4.07-1.47-5.34a2,2,0,0,1,1.71-1.07c2.93-.24,8.48,3.75,9.64,5.33a7.74,7.74,0,0,1,1.46,6.29l-.08.31-.31.05A6.22,6.22,0,0,1,69.82,314.8Zm-9.21-11.1h-.2a1,1,0,0,0-.9.53c-.45.89.08,2.53,1.38,4.28,2.21,3,6.18,5.66,9.64,5.24a6.92,6.92,0,0,0-1.37-5.13C68.15,307.26,63.12,303.7,60.61,303.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71,314.7a.47.47,0,0,1-.35-.14l-7-6.75a.49.49,0,0,1,0-.7.5.5,0,0,1,.71,0l7,6.75a.5.5,0,0,1-.34.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66,399.19a.52.52,0,0,1-.35-.14.49.49,0,0,1,0-.7l6.43-6.8a.5.5,0,0,1,.73.69L66.4,399A.48.48,0,0,1,66,399.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.51,393.93a7.31,7.31,0,0,1,2.56-5.46c1.65-1.48,10.34-5.14,11.16-2.08C85.13,389.72,76.24,396.26,70.51,393.93Z",
    style: {
      fill: "#DE0EEA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.15,394.91a7.45,7.45,0,0,1-2.83-.52l-.29-.12,0-.31a7.72,7.72,0,0,1,2.72-5.86c1.47-1.31,7.7-4.08,10.53-3.23a2,2,0,0,1,1.46,1.39c.37,1.38-.56,3.17-2.54,4.92A14.6,14.6,0,0,1,73.15,394.91ZM71,393.58c3.29,1.12,7.73-.69,10.5-3.15,1.64-1.44,2.49-2.94,2.23-3.9a1,1,0,0,0-.77-.7c-2.35-.7-8.28,1.85-9.58,3A6.94,6.94,0,0,0,71,393.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.51,394.43a.5.5,0,0,1-.26-.93L79,388.07a.5.5,0,0,1,.69.16.49.49,0,0,1-.16.69l-8.75,5.43A.56.56,0,0,1,70.51,394.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.26,358.5a.52.52,0,0,1-.35-.14.5.5,0,0,1,0-.71l6.42-6.8a.5.5,0,0,1,.73.69l-6.43,6.8A.52.52,0,0,1,70.26,358.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.73,353.23a7.29,7.29,0,0,1,2.56-5.45c1.65-1.48,10.34-5.14,11.17-2.08C89.35,349,80.46,355.57,74.73,353.23Z",
    style: {
      fill: "#DE0EEA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.38,354.22a7.5,7.5,0,0,1-2.84-.52l-.29-.12,0-.31A7.81,7.81,0,0,1,77,347.4c1.46-1.3,7.69-4.07,10.52-3.23a2,2,0,0,1,1.46,1.4c.37,1.38-.55,3.17-2.53,4.92A14.68,14.68,0,0,1,77.38,354.22Zm-2.14-1.33c3.29,1.12,7.73-.7,10.51-3.15,1.63-1.45,2.48-2.94,2.22-3.91a1,1,0,0,0-.77-.7c-2.34-.7-8.27,1.85-9.58,3A6.91,6.91,0,0,0,75.24,352.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.73,353.73a.49.49,0,0,1-.42-.23.5.5,0,0,1,.16-.69l8.76-5.43a.48.48,0,0,1,.68.16.49.49,0,0,1-.16.69L75,353.66A.52.52,0,0,1,74.73,353.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.11,340.61a.49.49,0,0,1-.36-.84l6.43-6.8a.5.5,0,0,1,.73.69l-6.43,6.8A.51.51,0,0,1,72.11,340.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.59,335.35a7.27,7.27,0,0,1,2.56-5.46c1.65-1.47,10.33-5.13,11.16-2.07C91.21,331.14,82.32,337.69,76.59,335.35Z",
    style: {
      fill: "#DE0EEA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.23,336.33a7.45,7.45,0,0,1-2.83-.52l-.29-.11,0-.32a7.72,7.72,0,0,1,2.72-5.86c1.47-1.31,7.7-4.08,10.53-3.23a2,2,0,0,1,1.45,1.4c.38,1.37-.55,3.16-2.53,4.92A14.66,14.66,0,0,1,79.23,336.33ZM77.09,335c3.29,1.12,7.73-.69,10.51-3.14,1.64-1.45,2.49-2.95,2.23-3.91a1,1,0,0,0-.77-.7c-2.35-.71-8.28,1.85-9.58,3A7,7,0,0,0,77.09,335Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.59,335.85a.47.47,0,0,1-.42-.24.48.48,0,0,1,.16-.68l8.75-5.44a.51.51,0,0,1,.69.16.5.5,0,0,1-.16.69l-8.76,5.44A.48.48,0,0,1,76.59,335.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.76,313.05a.52.52,0,0,1-.38-.17.51.51,0,0,1,.06-.71l6.5-5.46a.51.51,0,0,1,.71.07.5.5,0,0,1-.07.7l-6.5,5.46A.46.46,0,0,1,74.76,313.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.31,309.13a7.25,7.25,0,0,1,2.56-5.45c1.65-1.48,10.34-5.14,11.16-2.08C93.93,304.93,85,311.47,79.31,309.13Z",
    style: {
      fill: "#DE0EEA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82,310.12a7.45,7.45,0,0,1-2.83-.52l-.29-.12,0-.31a7.73,7.73,0,0,1,2.72-5.87c1.47-1.3,7.7-4.07,10.53-3.23a2,2,0,0,1,1.45,1.4c.38,1.37-.55,3.17-2.53,4.92A14.65,14.65,0,0,1,82,310.12Zm-2.14-1.33c3.3,1.12,7.74-.7,10.51-3.15,1.64-1.45,2.49-2.94,2.23-3.91a1,1,0,0,0-.77-.7c-2.35-.7-8.28,1.85-9.58,3A6.93,6.93,0,0,0,79.81,308.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 79.31,
    y1: 309.13,
    x2: 88.07,
    y2: 303.7,
    style: {
      fill: "#DE0EEA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.54,
    y: 305.92,
    width: 10.3,
    height: 1,
    transform: "translate(-149.01 90.21) rotate(-31.83)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.24,297.06a7.27,7.27,0,0,1,2.56-5.46c1.65-1.47,10.33-5.13,11.16-2.07C90.86,292.86,82,299.4,76.24,297.06Z",
    style: {
      fill: "#DE0EEA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.88,298a7.45,7.45,0,0,1-2.83-.52l-.29-.11,0-.32a7.73,7.73,0,0,1,2.72-5.86c1.46-1.31,7.7-4.07,10.53-3.23a2,2,0,0,1,1.45,1.4c.37,1.37-.55,3.17-2.53,4.92A14.66,14.66,0,0,1,78.88,298Zm-2.14-1.32c3.29,1.12,7.73-.7,10.51-3.15,1.63-1.45,2.49-2.95,2.23-3.91a1,1,0,0,0-.78-.7c-2.34-.7-8.27,1.85-9.57,3A7,7,0,0,0,76.74,296.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.24,297.56a.51.51,0,0,1-.43-.23.5.5,0,0,1,.17-.69l8.75-5.44a.5.5,0,1,1,.53.85l-8.76,5.44A.48.48,0,0,1,76.24,297.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6,297.45a7.28,7.28,0,0,1-5.16-3.11c-1.3-1.8-4-10.82-.9-11.32C74,282.47,79.52,292,76.6,297.45Z",
    style: {
      fill: "#DE0EEA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.89,298h-.31A7.73,7.73,0,0,1,71,294.63c-1.14-1.59-3.24-8.08-2.11-10.81a2,2,0,0,1,1.54-1.3c1.41-.22,3.1.88,4.63,3,2.4,3.36,3.84,8.61,2,12.13Zm-6.06-14.47-.21,0a1,1,0,0,0-.77.7c-.94,2.25,1,8.42,2,9.83a6.94,6.94,0,0,0,4.47,2.88c1.46-3.16.11-7.77-2-10.79C73.1,284.48,71.8,283.49,70.83,283.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6,298a.48.48,0,0,1-.45-.28l-4.49-9.28a.5.5,0,1,1,.9-.43l4.49,9.27a.51.51,0,0,1-.23.67A.44.44,0,0,1,76.6,298Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8,388.73a.47.47,0,0,1-.4-.2l-5.33-7.11a.5.5,0,0,1,.11-.7.51.51,0,0,1,.7.11l5.32,7.1a.5.5,0,0,1-.1.7A.49.49,0,0,1,59.8,388.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.21,383.35a7.3,7.3,0,0,0-2-5.69c-1.49-1.64-9.75-6.18-10.89-3.22C42.1,377.66,50.27,385.09,56.21,383.35Z",
    style: {
      fill: "#DE0EEA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.36,384.1c-3.4,0-7.15-2.15-9.48-4.68-1.79-1.95-2.52-3.83-2-5.16A2,2,0,0,1,44.46,373c2.91-.54,8.82,2.85,10.14,4.3a7.73,7.73,0,0,1,2.1,6.11l-.05.31-.3.09A7,7,0,0,1,54.36,384.1ZM45.16,374a2.67,2.67,0,0,0-.51.05,1,1,0,0,0-.85.61c-.36.94.34,2.51,1.82,4.12,2.5,2.72,6.73,5,10.12,4.22a6.85,6.85,0,0,0-1.88-5C52.76,376.79,47.77,374,45.16,374Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.21,383.85a.5.5,0,0,1-.31-.1l-7.69-6a.5.5,0,0,1,.61-.79l7.7,6a.5.5,0,0,1,.08.7A.48.48,0,0,1,56.21,383.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,354.44a.5.5,0,0,1-.34-.13l-5.51-5.13a.5.5,0,1,1,.69-.73l5.5,5.12a.5.5,0,0,1,0,.71A.49.49,0,0,1,60,354.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.21,351a7.3,7.3,0,0,0-2-5.69c-1.49-1.64-9.75-6.18-10.89-3.22C42.1,345.35,50.27,352.77,56.21,351Z",
    style: {
      fill: "#DE0EEA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.36,351.79c-3.4,0-7.15-2.15-9.48-4.69-1.79-1.94-2.52-3.82-2-5.15a2,2,0,0,1,1.59-1.24c2.91-.55,8.82,2.85,10.14,4.3a7.73,7.73,0,0,1,2.1,6.11l-.05.31-.3.09A7,7,0,0,1,54.36,351.79Zm-9.2-10.14a2.71,2.71,0,0,0-.51,0,1,1,0,0,0-.85.62c-.36.93.34,2.51,1.82,4.12,2.5,2.72,6.73,5,10.12,4.21a6.87,6.87,0,0,0-1.88-5C52.76,344.47,47.77,341.65,45.16,341.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.21,351.54a.51.51,0,0,1-.31-.11l-7.69-6a.5.5,0,0,1,.61-.79l7.7,6a.52.52,0,0,1,.08.71A.51.51,0,0,1,56.21,351.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.17,318.8a.51.51,0,0,1-.4-.2l-5.69-7.42a.5.5,0,0,1,.79-.61L60.56,318a.51.51,0,0,1-.09.71A.49.49,0,0,1,60.17,318.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.21,313.1a7.3,7.3,0,0,0-2-5.69c-1.49-1.64-9.75-6.18-10.89-3.22C42.1,307.41,50.27,314.83,56.21,313.1Z",
    style: {
      fill: "#DE0EEA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.36,313.85c-3.4,0-7.15-2.15-9.48-4.68-1.79-1.95-2.52-3.83-2-5.16a2,2,0,0,1,1.59-1.24c2.9-.55,8.82,2.85,10.14,4.3a7.73,7.73,0,0,1,2.1,6.11l-.05.31-.3.09A7,7,0,0,1,54.36,313.85Zm-9.2-10.14a2.64,2.64,0,0,0-.51,0,1,1,0,0,0-.85.62c-.36.93.34,2.51,1.82,4.12,2.5,2.72,6.73,5,10.12,4.22a6.88,6.88,0,0,0-1.88-5C52.76,306.54,47.77,303.71,45.16,303.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.21,313.6a.5.5,0,0,1-.31-.1l-7.69-6a.5.5,0,0,1,.61-.79l7.7,6a.5.5,0,0,1,.08.7A.48.48,0,0,1,56.21,313.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8,290.92a.55.55,0,0,1-.34-.13L54.14,286a.51.51,0,0,1,0-.71.5.5,0,0,1,.71,0L60.13,290a.5.5,0,0,1,0,.71A.51.51,0,0,1,59.8,290.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.21,287.85a7.33,7.33,0,0,0-2-5.7c-1.49-1.63-9.75-6.17-10.89-3.21C42.1,282.15,50.27,289.58,56.21,287.85Z",
    style: {
      fill: "#DE0EEA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.36,288.6c-3.4,0-7.15-2.16-9.48-4.69-1.79-2-2.52-3.82-2-5.15a2,2,0,0,1,1.59-1.24c2.91-.55,8.82,2.85,10.14,4.3a7.73,7.73,0,0,1,2.1,6.11l-.05.31-.3.09A7.35,7.35,0,0,1,54.36,288.6Zm-9.2-10.14a2.71,2.71,0,0,0-.51,0,1,1,0,0,0-.85.62c-.36.93.34,2.51,1.82,4.11,2.5,2.73,6.73,5,10.12,4.22a6.87,6.87,0,0,0-1.88-5C52.76,281.28,47.77,278.46,45.16,278.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.21,288.35a.51.51,0,0,1-.31-.11l-7.69-6a.5.5,0,0,1,.61-.79l7.7,6a.5.5,0,0,1,.08.7A.49.49,0,0,1,56.21,288.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1,265.65a.46.46,0,0,1-.29-.1l-5.52-4.05a.51.51,0,0,1-.11-.7.5.5,0,0,1,.7-.1l5.52,4a.51.51,0,0,1,.11.7A.49.49,0,0,1,60.1,265.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.21,262.48a7.3,7.3,0,0,0-2-5.69c-1.49-1.64-9.75-6.18-10.89-3.22C42.1,256.79,50.27,264.21,56.21,262.48Z",
    style: {
      fill: "#DE0EEA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.36,263.23c-3.4,0-7.15-2.15-9.48-4.69-1.79-1.94-2.52-3.82-2-5.15a2,2,0,0,1,1.59-1.24c2.91-.55,8.82,2.85,10.14,4.3a7.73,7.73,0,0,1,2.1,6.11l-.05.31-.3.09A7,7,0,0,1,54.36,263.23Zm-9.2-10.14a2.71,2.71,0,0,0-.51,0,1,1,0,0,0-.85.62c-.36.93.34,2.51,1.82,4.12,2.5,2.72,6.73,5,10.12,4.21a6.87,6.87,0,0,0-1.88-5C52.76,255.92,47.77,253.09,45.16,253.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.21,263a.5.5,0,0,1-.31-.1l-7.69-6a.5.5,0,0,1,.61-.79l7.7,6a.5.5,0,0,1-.31.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.15,397.32a.45.45,0,0,1-.31-.11.5.5,0,0,1-.09-.7l4.59-5.83a.5.5,0,0,1,.7-.08.5.5,0,0,1,.09.7l-4.59,5.83A.52.52,0,0,1,61.15,397.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,393.22a7.3,7.3,0,0,1,2-5.69c1.49-1.64,9.76-6.18,10.89-3.22C78.11,387.53,69.94,395,64,393.22Z",
    style: {
      fill: "#DE0EEA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.85,394a7,7,0,0,1-2-.27l-.3-.09-.05-.31a7.73,7.73,0,0,1,2.1-6.11c1.32-1.45,7.24-4.85,10.14-4.3a2,2,0,0,1,1.59,1.24c.51,1.33-.22,3.21-2,5.15C73,391.82,69.25,394,65.85,394Zm-1.38-1.15c3.39.78,7.61-1.49,10.12-4.21,1.48-1.61,2.18-3.19,1.82-4.12a1,1,0,0,0-.85-.62c-2.39-.44-8,2.7-9.21,4A6.87,6.87,0,0,0,64.47,392.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,393.72a.5.5,0,0,1-.3-.9l8.14-6.3a.51.51,0,0,1,.71.09.52.52,0,0,1-.09.7l-8.15,6.31A.5.5,0,0,1,64,393.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,347.52a.49.49,0,0,1-.39-.8l5.69-7.43a.51.51,0,0,1,.7-.09.5.5,0,0,1,.09.7l-5.69,7.43A.5.5,0,0,1,60,347.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,341.83a7.33,7.33,0,0,1,2-5.7c1.49-1.63,9.76-6.17,10.89-3.21C78.11,336.13,69.94,343.56,64,341.83Z",
    style: {
      fill: "#DE0EEA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.85,342.58a7.35,7.35,0,0,1-2-.27l-.3-.09-.05-.31a7.73,7.73,0,0,1,2.1-6.11c1.32-1.45,7.24-4.84,10.14-4.3a2,2,0,0,1,1.59,1.24c.51,1.33-.22,3.21-2,5.15C73,340.42,69.25,342.58,65.85,342.58Zm-1.38-1.15c3.39.78,7.61-1.49,10.12-4.22,1.48-1.6,2.18-3.18,1.82-4.11a1,1,0,0,0-.85-.62c-2.39-.44-8,2.7-9.21,4A6.87,6.87,0,0,0,64.47,341.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,342.33a.49.49,0,0,1-.39-.2.5.5,0,0,1,.09-.7l8.14-6.31a.51.51,0,0,1,.71.09.51.51,0,0,1-.09.7l-8.15,6.31A.51.51,0,0,1,64,342.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,322.16a.49.49,0,0,1-.3-.1.51.51,0,0,1-.09-.71l5.69-7.42a.5.5,0,0,1,.79.61L60.44,322A.51.51,0,0,1,60,322.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,316.46a7.3,7.3,0,0,1,2-5.69c1.49-1.64,9.76-6.18,10.89-3.22C78.11,310.77,69.94,318.19,64,316.46Z",
    style: {
      fill: "#DE0EEA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.85,317.21a7,7,0,0,1-2-.27l-.3-.09-.05-.31a7.73,7.73,0,0,1,2.1-6.11c1.32-1.45,7.24-4.85,10.14-4.3a2,2,0,0,1,1.59,1.24c.51,1.33-.22,3.21-2,5.16C73,315.06,69.25,317.21,65.85,317.21Zm-1.38-1.14c3.39.78,7.61-1.49,10.12-4.22,1.48-1.61,2.18-3.19,1.82-4.12a1,1,0,0,0-.85-.61c-2.39-.46-8,2.69-9.21,4A6.88,6.88,0,0,0,64.47,316.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,317a.48.48,0,0,1-.39-.19.5.5,0,0,1,.09-.7l8.14-6.31a.51.51,0,0,1,.71.09.51.51,0,0,1-.09.7l-8.15,6.31A.5.5,0,0,1,64,317Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,288.63a.49.49,0,0,1-.39-.8l5.69-7.43a.5.5,0,1,1,.79.61l-5.69,7.43A.5.5,0,0,1,60,288.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,282.93a7.3,7.3,0,0,1,2-5.69c1.49-1.64,9.76-6.17,10.89-3.22C78.11,277.24,69.94,284.67,64,282.93Z",
    style: {
      fill: "#DE0EEA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.85,283.69a7,7,0,0,1-2-.28l-.3-.08-.05-.31a7.73,7.73,0,0,1,2.1-6.11c1.32-1.46,7.24-4.85,10.14-4.3a2,2,0,0,1,1.59,1.23c.51,1.34-.22,3.21-2,5.16C73,281.53,69.25,283.69,65.85,283.69Zm-1.38-1.15c3.39.77,7.61-1.49,10.12-4.22,1.48-1.6,2.18-3.18,1.82-4.12a1,1,0,0,0-.85-.61c-2.39-.46-8,2.7-9.21,4A6.87,6.87,0,0,0,64.47,282.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,283.43a.48.48,0,0,1-.39-.19.5.5,0,0,1,.09-.7l8.14-6.31a.51.51,0,0,1,.71.09.51.51,0,0,1-.09.7l-8.15,6.31A.5.5,0,0,1,64,283.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.29,259.7a.53.53,0,0,1-.4-.19.51.51,0,0,1,.09-.71l5.58-4.35a.5.5,0,0,1,.7.09.5.5,0,0,1-.08.7l-5.58,4.35A.53.53,0,0,1,60.29,259.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,256.58a7.33,7.33,0,0,1,2-5.7c1.49-1.63,9.76-6.17,10.89-3.21C78.11,250.88,69.94,258.31,64,256.58Z",
    style: {
      fill: "#DE0EEA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.85,257.33a7.35,7.35,0,0,1-2-.27l-.3-.09-.05-.31a7.73,7.73,0,0,1,2.1-6.11c1.32-1.45,7.23-4.85,10.14-4.3a2,2,0,0,1,1.59,1.24c.51,1.33-.22,3.21-2,5.15C73,255.17,69.25,257.33,65.85,257.33Zm-1.38-1.15c3.39.78,7.62-1.49,10.12-4.22,1.48-1.6,2.18-3.18,1.82-4.11a1,1,0,0,0-.85-.62c-2.39-.44-8,2.7-9.21,4A7,7,0,0,0,64.47,256.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,257.08a.49.49,0,0,1-.39-.2.5.5,0,0,1,.09-.7l8.14-6.31a.51.51,0,0,1,.71.09.51.51,0,0,1-.09.7L64.31,257A.51.51,0,0,1,64,257.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7,244.89a7.33,7.33,0,0,1,2-5.7c1.49-1.63,9.75-6.17,10.89-3.21C73.81,239.19,65.64,246.62,59.7,244.89Z",
    style: {
      fill: "#DE0EEA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.55,245.64a7.35,7.35,0,0,1-2-.27l-.3-.09,0-.31a7.73,7.73,0,0,1,2.1-6.11c1.32-1.45,7.23-4.85,10.14-4.3A2,2,0,0,1,73,235.8c.51,1.33-.22,3.21-2,5.15C68.7,243.48,65,245.64,61.55,245.64Zm-1.39-1.15c3.39.78,7.62-1.49,10.13-4.22,1.48-1.6,2.17-3.18,1.81-4.11a1,1,0,0,0-.84-.62c-2.39-.46-8,2.7-9.21,4A6.94,6.94,0,0,0,60.16,244.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7,245.39a.47.47,0,0,1-.39-.2.5.5,0,0,1,.09-.7l8.14-6.31a.49.49,0,0,1,.7.09.5.5,0,0,1-.08.7L60,245.28A.51.51,0,0,1,59.7,245.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1,245.24a7.27,7.27,0,0,1-5.45-2.57c-1.48-1.65-5.12-10.35-2.06-11.17C55.92,230.61,62.44,239.51,60.1,245.24Z",
    style: {
      fill: "#DE0EEA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,245.74a7.84,7.84,0,0,1-5.7-2.74c-1.3-1.46-4.06-7.7-3.21-10.53a2,2,0,0,1,1.4-1.45c1.37-.37,3.17.56,4.91,2.54,2.73,3.1,4.7,8.17,3.19,11.87l-.12.29-.31,0Zm-6.89-13.8a1.36,1.36,0,0,0-.36.05c-.22,0-.53.2-.7.77-.7,2.34,1.84,8.27,3,9.58a6.9,6.9,0,0,0,4.73,2.39c1.13-3.29-.68-7.73-3.13-10.51C55.35,232.78,54,231.94,53.08,231.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1,245.74a.52.52,0,0,1-.43-.24l-5.42-8.77a.49.49,0,0,1,.17-.68.48.48,0,0,1,.68.16L60.52,245a.51.51,0,0,1-.42.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "67.11 459 48.9 459 46.62 413.01 69.38 413.01 67.11 459",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1,459.5H48.9a.5.5,0,0,1-.5-.48l-2.28-46a.47.47,0,0,1,.14-.37.48.48,0,0,1,.36-.16H69.38a.48.48,0,0,1,.36.16.47.47,0,0,1,.14.37L67.6,459A.5.5,0,0,1,67.1,459.5Zm-17.73-1H66.63l2.23-45H47.14Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Picture--inject-53"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "364.55 93.88 363.55 93.88 363.55 57.5 416.23 57.5 416.23 58.5 364.55 58.5 364.55 93.88",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "442.55 147.5 363.55 147.5 363.55 99.32 364.55 99.32 364.55 146.5 441.55 146.5 441.55 58.5 420.07 58.5 420.07 57.5 442.55 57.5 442.55 147.5",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "432.03 135.5 418.15 135.5 418.15 134.5 431.03 134.5 431.03 70.5 375.06 70.5 375.06 134.5 413.67 134.5 413.67 135.5 374.06 135.5 374.06 69.5 432.03 69.5 432.03 135.5",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.5,115.5H391.59v-26H414.5Zm-21.91-1H413.5v-24H392.59Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M272.63,51.54H215.46l-.06.21c-1.69,6.09-5.58,10-9.9,10H203c-4.31,0-8.21-3.95-9.9-10l-.06-.21H135.89a28.83,28.83,0,0,0-28.83,28.83V367.85a28.83,28.83,0,0,0,28.83,28.83H272.63a28.83,28.83,0,0,0,28.83-28.83V80.37A28.83,28.83,0,0,0,272.63,51.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.63,397.18H135.89a29.36,29.36,0,0,1-29.33-29.33V80.37A29.37,29.37,0,0,1,135.89,51h57.17a.49.49,0,0,1,.48.37l.06.2c1.63,5.88,5.33,9.68,9.42,9.68h2.48c4.09,0,7.79-3.8,9.42-9.68l.06-.2a.5.5,0,0,1,.48-.37h57.17A29.37,29.37,0,0,1,302,80.37V367.85A29.36,29.36,0,0,1,272.63,397.18ZM135.89,52a28.36,28.36,0,0,0-28.33,28.33V367.85a28.36,28.36,0,0,0,28.33,28.33H272.63A28.36,28.36,0,0,0,301,367.85V80.37A28.36,28.36,0,0,0,272.63,52H215.84c-1.78,6.23-5.82,10.25-10.34,10.25H203c-4.51,0-8.56-4-10.34-10.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.63,51.54H215.46l-.06.21c-1.69,6.09-5.58,10-9.9,10H203c-4.31,0-8.21-3.95-9.9-10l-.06-.21H135.89a28.83,28.83,0,0,0-28.83,28.83V367.85a28.83,28.83,0,0,0,28.83,28.83H272.63a28.83,28.83,0,0,0,28.83-28.83V80.37A28.83,28.83,0,0,0,272.63,51.54Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.06,176.78V367.85a28.83,28.83,0,0,0,28.83,28.83H272.63a28.83,28.83,0,0,0,28.83-28.83V176.78Z",
    style: {
      fill: "#DE0EEA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.63,397.18H135.89a29.36,29.36,0,0,1-29.33-29.33V176.78a.5.5,0,0,1,.5-.5h194.4a.5.5,0,0,1,.5.5V367.85A29.36,29.36,0,0,1,272.63,397.18ZM107.56,177.28V367.85a28.36,28.36,0,0,0,28.33,28.33H272.63A28.36,28.36,0,0,0,301,367.85V177.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.36,347.82H134a5.49,5.49,0,0,0-5.49,5.5v17.84a5.49,5.49,0,0,0,5.49,5.49H156.1L162,387.17l1.17-10.52h5.24a5.49,5.49,0,0,0,5.49-5.49V353.32A5.49,5.49,0,0,0,168.36,347.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162,387.67a.5.5,0,0,1-.44-.25l-5.7-10.27H134a6,6,0,0,1-6-6V353.32a6,6,0,0,1,6-6h34.32a6,6,0,0,1,6,6v17.84a6,6,0,0,1-6,6h-4.79l-1.12,10.08a.52.52,0,0,1-.4.44ZM134,348.32a5,5,0,0,0-5,5v17.84a5,5,0,0,0,5,5H156.1a.5.5,0,0,1,.44.26l5.09,9.15,1-9a.51.51,0,0,1,.5-.45h5.24a5,5,0,0,0,5-5V353.32a5,5,0,0,0-5-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.65,362.92a2.29,2.29,0,1,1-2.29-2.28A2.29,2.29,0,0,1,142.65,362.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.36,365.71a2.79,2.79,0,1,1,2.79-2.79A2.79,2.79,0,0,1,140.36,365.71Zm0-4.57a1.79,1.79,0,1,0,1.79,1.78A1.79,1.79,0,0,0,140.36,361.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.63,362.92a2.29,2.29,0,1,1-2.29-2.28A2.28,2.28,0,0,1,153.63,362.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.34,365.71a2.79,2.79,0,1,1,2.79-2.79A2.8,2.8,0,0,1,151.34,365.71Zm0-4.57a1.79,1.79,0,1,0,1.79,1.78A1.79,1.79,0,0,0,151.34,361.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.61,362.92a2.29,2.29,0,1,1-2.29-2.28A2.28,2.28,0,0,1,164.61,362.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.32,365.71a2.79,2.79,0,1,1,2.79-2.79A2.79,2.79,0,0,1,162.32,365.71Zm0-4.57a1.79,1.79,0,1,0,1.79,1.78A1.78,1.78,0,0,0,162.32,361.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.12,400.31h27V393c-9.28-16.62-30.53-54.95-33.41-62.17-3.71-9.27-6.5-13.91-11.13-25.66s-11.75-20.41-15.77-22.26-8.66-4.33-7.42-.62,5.25,6.8,6.49,8.35-7.63,15.58-6.75,19.69,1.8,9.68,7.37,14.94a84.61,84.61,0,0,0,11.44,9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.09,400.81h-27a.51.51,0,0,1-.47-.34l-22.16-65.9a87.09,87.09,0,0,1-11.37-8.93c-5.39-5.09-6.54-10.56-7.38-14.55l-.13-.64c-.52-2.41,1.81-7.41,4.06-12.24,1.3-2.79,3.08-6.62,2.78-7.26-.3-.37-.82-.89-1.41-1.48-1.78-1.76-4.21-4.17-5.16-7-.13-.4-.53-1.6.19-2.24,1-.89,3.26.06,6.85,1.75l1.07.49c4.28,2,11.45,11,16,22.54,2.5,6.33,4.44,10.55,6.32,14.63,1.59,3.47,3.1,6.75,4.81,11,2.88,7.2,24.31,45.83,33.38,62.11a.42.42,0,0,1,.07.24v7.3A.5.5,0,0,1,303.09,400.81Zm-26.61-1h26.11v-6.67c-9.13-16.36-30.48-54.88-33.38-62.11-1.7-4.26-3.2-7.52-4.79-11-1.88-4.1-3.83-8.33-6.34-14.69-4.48-11.35-11.41-20.09-15.51-22l-1.07-.5c-2.06-1-5.18-2.42-5.76-1.91-.11.1-.15.46.09,1.18.87,2.62,3.21,4.93,4.91,6.62.62.62,1.15,1.15,1.5,1.58.69.86-.18,3-2.66,8.29-2,4.25-4.44,9.53-4,11.61l.14.65c.86,4.07,1.93,9.15,7.09,14a86.35,86.35,0,0,0,11.36,8.9.53.53,0,0,1,.21.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.52,
    y: 239.5,
    width: 5.28,
    height: 120.44,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.8,360.44h-5.28a.5.5,0,0,1-.5-.5V239.5a.5.5,0,0,1,.5-.5h5.28a.51.51,0,0,1,.5.5V359.94A.5.5,0,0,1,246.8,360.44Zm-4.78-1h4.28V240H242Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.85,
    y: 200.8,
    width: 93.42,
    height: 40.7,
    rx: 7.67,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.6,243H205.52a9.18,9.18,0,0,1-9.17-9.17V208.47a9.18,9.18,0,0,1,9.17-9.17H283.6a9.18,9.18,0,0,1,9.17,9.17v25.37A9.18,9.18,0,0,1,283.6,243ZM205.52,202.3a6.18,6.18,0,0,0-6.17,6.17v25.37a6.18,6.18,0,0,0,6.17,6.17H283.6a6.18,6.18,0,0,0,6.17-6.17V208.47a6.18,6.18,0,0,0-6.17-6.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "209.97 212.41 211.83 218.15 217.86 218.15 212.98 221.7 214.84 227.44 209.97 223.89 205.09 227.44 206.95 221.7 202.07 218.15 208.1 218.15 209.97 212.41",
    style: {
      fill: "#DE0EEA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.08,227.93a.52.52,0,0,1-.29-.09.5.5,0,0,1-.18-.56l1.75-5.39-4.59-3.33a.52.52,0,0,1-.18-.56.5.5,0,0,1,.48-.35h5.67l1.75-5.39a.52.52,0,0,1,.95,0l1.75,5.39h5.67a.5.5,0,0,1,.48.35.52.52,0,0,1-.18.56l-4.59,3.33,1.75,5.39a.5.5,0,0,1-.18.56.5.5,0,0,1-.59,0L210,224.51l-4.59,3.33A.53.53,0,0,1,205.08,227.93Zm-1.47-9.28,3.63,2.64a.49.49,0,0,1,.18.56L206,226.13l3.63-2.65a.53.53,0,0,1,.59,0l3.63,2.65-1.38-4.28a.49.49,0,0,1,.18-.56l3.63-2.64h-4.49a.51.51,0,0,1-.48-.34L210,214l-1.39,4.28a.51.51,0,0,1-.48.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "227.68 212.41 229.54 218.15 235.57 218.15 230.69 221.7 232.56 227.44 227.68 223.89 222.8 227.44 224.66 221.7 219.78 218.15 225.81 218.15 227.68 212.41",
    style: {
      fill: "#DE0EEA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.8,227.93a.55.55,0,0,1-.3-.09.52.52,0,0,1-.18-.56l1.75-5.39-4.58-3.33a.5.5,0,0,1,.29-.91h5.67l1.75-5.39a.52.52,0,0,1,1,0l1.76,5.39h5.66a.5.5,0,0,1,.3.91l-4.59,3.33,1.75,5.39a.49.49,0,0,1-.18.56.49.49,0,0,1-.59,0l-4.58-3.33-4.59,3.33A.52.52,0,0,1,222.8,227.93Zm4.88-4.54a.52.52,0,0,1,.29.09l3.64,2.65-1.39-4.28a.51.51,0,0,1,.18-.56l3.64-2.64h-4.5a.5.5,0,0,1-.47-.34L227.68,214l-1.39,4.28a.51.51,0,0,1-.48.34h-4.49l3.64,2.64a.51.51,0,0,1,.18.56l-1.39,4.28,3.63-2.65A.55.55,0,0,1,227.68,223.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "245.39 212.41 247.26 218.15 253.29 218.15 248.41 221.7 250.27 227.44 245.39 223.89 240.51 227.44 242.38 221.7 237.5 218.15 243.53 218.15 245.39 212.41",
    style: {
      fill: "#DE0EEA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.51,227.93a.52.52,0,0,1-.29-.09.49.49,0,0,1-.18-.56l1.75-5.39-4.59-3.33a.5.5,0,0,1,.3-.91h5.66l1.76-5.39a.52.52,0,0,1,1,0l1.75,5.39h5.67a.5.5,0,0,1,.29.91L249,221.89l1.75,5.39a.52.52,0,0,1-.18.56.49.49,0,0,1-.59,0l-4.59-3.33-4.58,3.33A.55.55,0,0,1,240.51,227.93Zm4.88-4.54a.53.53,0,0,1,.3.09l3.63,2.65-1.39-4.28a.52.52,0,0,1,.18-.56l3.64-2.64h-4.49a.51.51,0,0,1-.48-.34L245.39,214,244,218.31a.5.5,0,0,1-.47.34H239l3.64,2.64a.49.49,0,0,1,.18.56l-1.39,4.28,3.64-2.65A.52.52,0,0,1,245.39,223.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "263.11 212.41 264.97 218.15 271 218.15 266.12 221.7 267.99 227.44 263.11 223.89 258.23 227.44 260.09 221.7 255.21 218.15 261.24 218.15 263.11 212.41",
    style: {
      fill: "#DE0EEA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268,227.93a.53.53,0,0,1-.3-.09l-4.58-3.33-4.59,3.33a.5.5,0,0,1-.59,0,.5.5,0,0,1-.18-.56l1.75-5.39-4.58-3.33a.51.51,0,0,1-.19-.56.5.5,0,0,1,.48-.35h5.67l1.75-5.39a.52.52,0,0,1,.95,0l1.75,5.39H271a.5.5,0,0,1,.48.35.52.52,0,0,1-.18.56l-4.59,3.33,1.75,5.39a.5.5,0,0,1-.18.56A.52.52,0,0,1,268,227.93Zm-4.88-4.54a.52.52,0,0,1,.29.09l3.63,2.65-1.38-4.28a.49.49,0,0,1,.18-.56l3.63-2.64H265a.51.51,0,0,1-.48-.34L263.11,214l-1.39,4.28a.51.51,0,0,1-.48.34h-4.49l3.63,2.64a.49.49,0,0,1,.18.56l-1.38,4.28,3.63-2.65A.53.53,0,0,1,263.11,223.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "280.82 212.41 282.68 218.15 288.71 218.15 283.83 221.7 285.7 227.44 280.82 223.89 275.94 227.44 277.8 221.7 272.92 218.15 278.95 218.15 280.82 212.41",
    style: {
      fill: "#DE0EEA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.94,227.93a.53.53,0,0,1-.3-.09.52.52,0,0,1-.18-.56l1.75-5.39-4.58-3.33a.5.5,0,0,1,.29-.91h5.67l1.75-5.39a.5.5,0,0,1,.48-.34h0a.47.47,0,0,1,.47.34l1.76,5.39h5.66a.5.5,0,0,1,.3.91l-4.59,3.33,1.75,5.39a.49.49,0,0,1-.18.56.48.48,0,0,1-.58,0l-4.59-3.33-4.59,3.33A.52.52,0,0,1,275.94,227.93Zm-1.48-9.28,3.64,2.64a.52.52,0,0,1,.18.56l-1.39,4.28,3.64-2.65a.51.51,0,0,1,.58,0l3.64,2.65-1.39-4.28a.51.51,0,0,1,.18-.56l3.64-2.64h-4.5a.5.5,0,0,1-.47-.34L280.82,214l-1.39,4.28a.51.51,0,0,1-.47.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.93,322.8s-8.35-8.65-9-13.6a106.25,106.25,0,0,1-.62-12.37c0-1.85-2.47-14.22-2.47-18.55s4.33-9.28,5.25-7.11,0,11.44,3.41,16.39,7.73,16.38,8.65,21.95a102.29,102.29,0,0,1,.93,13.6",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.11,323.61a.5.5,0,0,1-.5-.5,102.74,102.74,0,0,0-.92-13.52c-.9-5.4-5.12-16.72-8.58-21.75-2.33-3.4-2.69-8.65-2.94-12.49a16.89,16.89,0,0,0-.51-4c-.09-.23-.19-.25-.36-.21-1.26.26-3.93,3.79-3.93,7.12A108.65,108.65,0,0,0,248,290.76c.48,3,.86,5.3.86,6.07a105.35,105.35,0,0,0,.62,12.31c.59,4.72,8.74,13.23,8.83,13.32a.5.5,0,0,1,0,.71.49.49,0,0,1-.7,0c-.35-.36-8.47-8.83-9.11-13.89a107.59,107.59,0,0,1-.62-12.43c0-.69-.39-3.11-.85-5.91-.72-4.45-1.62-10-1.62-12.64,0-3.54,2.75-7.7,4.73-8.1a1.25,1.25,0,0,1,1.48.79,16.43,16.43,0,0,1,.58,4.31c.25,3.72.59,8.82,2.78,12,3.52,5.13,7.82,16.66,8.74,22.16a104.18,104.18,0,0,1,.93,13.68A.5.5,0,0,1,264.11,323.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.94,281.68s-8.35-6.8-10.2-3.71-.93,5.88,1.85,6.8,7.73,4,8.66.93S244.94,281.68,244.94,281.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.35,287.54a14.27,14.27,0,0,1-4.9-1.48c-.74-.32-1.43-.62-2-.81a4.45,4.45,0,0,1-2.89-2.64,5.73,5.73,0,0,1,.77-4.9,2.08,2.08,0,0,1,1.5-1c3-.54,8.77,4,9.44,4.58.2.15,1.46,1.29.48,4.55a2.22,2.22,0,0,1-1.19,1.46A2.75,2.75,0,0,1,243.35,287.54Zm-7-9.88a2.22,2.22,0,0,0-.37,0,1.1,1.1,0,0,0-.81.54,4.72,4.72,0,0,0-.69,4,3.43,3.43,0,0,0,2.27,2c.62.21,1.34.51,2.09.84,1.85.79,4.16,1.78,5.28,1.26a1.25,1.25,0,0,0,.65-.84c.8-2.65-.13-3.48-.14-3.49l.31-.39-.32.39C243.06,280.79,238.69,277.66,236.35,277.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.63,293.12s-8.66-8-10.2-5.25-1.86,5.87.93,7.73,9.89,6.8,11.44,4S244.63,293.12,244.63,293.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.18,300.94c-2.74,0-7.2-3-9.69-4.66l-.41-.27c-2.67-1.78-3.06-4.83-1.09-8.39a1.58,1.58,0,0,1,1.18-.81c2.83-.45,9.1,5.29,9.8,5.95h0c.17.16,4,4,2.25,7.09a2,2,0,0,1-1.35,1A3.08,3.08,0,0,1,245.18,300.94Zm-9.64-13.16h-.21a.64.64,0,0,0-.47.32c-1,1.79-2.21,5.08.77,7.07l.41.27c2.22,1.49,7.42,5,9.61,4.44a1,1,0,0,0,.71-.52c1.32-2.37-1.92-5.73-2.08-5.89C241.84,291.22,237.43,287.78,235.54,287.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244,301.16s-8.65-8-10.2-5.26-1.86,5.88.93,7.73,9.89,6.81,11.44,4S244,301.16,244,301.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.56,309c-2.74,0-7.2-3-9.69-4.65l-.41-.28c-2.67-1.78-3.06-4.83-1.09-8.39a1.58,1.58,0,0,1,1.19-.81c2.8-.45,9.09,5.29,9.79,5.94l0,0c.16.16,3.95,4,2.24,7.09a2,2,0,0,1-1.34,1A2.71,2.71,0,0,1,244.56,309Zm-9.64-13.16h-.21a.58.58,0,0,0-.46.32c-1,1.78-2.22,5.08.76,7.07l.42.28c2.22,1.48,7.41,4.95,9.6,4.43a1,1,0,0,0,.71-.52c1.32-2.37-1.92-5.73-2.08-5.89C241.22,299.26,236.81,295.82,234.92,295.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.85,308.54s-6.3-5.86-7.43-3.83-1.35,4.28.68,5.63,7.2,5,8.33,2.93S241.85,308.54,241.85,308.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.26,314.37c-2,0-5.32-2.19-7.15-3.41l-.29-.2c-2-1.32-2.29-3.67-.84-6.29a1.28,1.28,0,0,1,1-.66c2.07-.35,6.41,3.58,7.25,4.36l0,0c.12.12,2.95,3,1.66,5.32a1.62,1.62,0,0,1-1.07.8A2.35,2.35,0,0,1,242.26,314.37Zm-7-9.59h-.14a.29.29,0,0,0-.24.17c-.7,1.26-1.57,3.58.51,5l.3.19c1.6,1.08,5.36,3.59,6.89,3.22A.59.59,0,0,0,243,313c.91-1.63-1.36-4-1.49-4.13C239.74,307.27,236.57,304.78,235.24,304.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.52,405l1.33-3.94a84.93,84.93,0,0,0,11.44-9c5.57-5.25,6.49-10.82,7.37-14.93s-8-18.15-6.75-19.7,5.25-4.63,6.49-8.34-3.4-1.24-7.42.61S187.85,360.23,183.21,372s-7.42,16.38-11.13,25.66c-.56,1.4-1.82,4-3.54,7.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.52,405.48h-18a.51.51,0,0,1-.43-.24.5.5,0,0,1,0-.49c1.81-3.53,3-6,3.52-7.3,1.71-4.27,3.21-7.55,4.81-11,1.88-4.08,3.82-8.3,6.32-14.64,4.57-11.58,11.74-20.55,16-22.53l1.06-.49c3.6-1.69,5.85-2.65,6.86-1.76.72.65.32,1.85.19,2.24-.95,2.85-3.38,5.26-5.16,7a19.33,19.33,0,0,0-1.42,1.49c-.29.63,1.49,4.45,2.79,7.24,2.25,4.84,4.57,9.84,4.06,12.24l-.14.65c-.84,4-2,9.46-7.38,14.55a86.57,86.57,0,0,1-11.36,8.93L187,405.14A.5.5,0,0,1,186.52,405.48Zm-17.16-1h16.81l1.21-3.6a.47.47,0,0,1,.2-.26A85.66,85.66,0,0,0,199,391.71c5.16-4.88,6.23-9.95,7.09-14l.13-.64c.45-2.08-2-7.37-4-11.61-2.48-5.34-3.35-7.43-2.66-8.3a19.89,19.89,0,0,1,1.5-1.57c1.7-1.69,4-4,4.91-6.62.24-.72.2-1.08.09-1.18-.58-.52-3.7.95-5.76,1.91l-1.07.5c-4.11,1.89-11,10.64-15.51,22-2.51,6.36-4.46,10.59-6.34,14.69-1.59,3.46-3.09,6.72-4.8,11C172.05,399.07,171,401.31,169.36,404.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.96,
    y: 306.3,
    width: 5.28,
    height: 99.9,
    transform: "translate(395.2 712.5) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.24,406.7H195a.5.5,0,0,1-.5-.5V306.3a.5.5,0,0,1,.5-.5h5.28a.5.5,0,0,1,.5.5v99.9A.5.5,0,0,1,200.24,406.7Zm-4.78-1h4.28V306.8h-4.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.83,389.6s8.35-8.66,9-13.6a106.33,106.33,0,0,0,.62-12.37c0-1.86,2.47-14.22,2.47-18.55s-4.33-9.28-5.26-7.11,0,11.44-3.4,16.38-7.73,16.39-8.66,22a103.39,103.39,0,0,0-.92,13.6",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.65,390.41h0a.5.5,0,0,1-.5-.5,104.39,104.39,0,0,1,.93-13.69c.92-5.49,5.21-17,8.74-22.15,2.18-3.18,2.52-8.27,2.77-12a16.8,16.8,0,0,1,.58-4.31,1.27,1.27,0,0,1,1.49-.8c2,.41,4.73,4.57,4.73,8.11a108.4,108.4,0,0,1-1.63,12.64c-.45,2.8-.84,5.21-.84,5.91a105.89,105.89,0,0,1-.63,12.43c-.63,5.05-8.75,13.53-9.1,13.89a.5.5,0,1,1-.72-.7c.08-.08,8.24-8.59,8.83-13.32a105.12,105.12,0,0,0,.62-12.3c0-.78.38-3.11.86-6.07a111.22,111.22,0,0,0,1.61-12.48c0-3.33-2.67-6.87-3.94-7.13-.16,0-.26,0-.36.21a17.23,17.23,0,0,0-.5,4c-.26,3.83-.61,9.09-3,12.49-3.45,5-7.67,16.35-8.57,21.75a102.74,102.74,0,0,0-.92,13.52A.5.5,0,0,1,177.65,390.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.82,348.48s8.34-6.8,10.2-3.71.93,5.87-1.86,6.8-7.73,4-8.65.93S196.82,348.48,196.82,348.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.41,354.34a2.7,2.7,0,0,1-1.19-.24,2.22,2.22,0,0,1-1.19-1.46c-1-3.26.28-4.4.48-4.55.66-.55,6.39-5.12,9.44-4.58a2.08,2.08,0,0,1,1.5,1,5.71,5.71,0,0,1,.77,4.89,4.46,4.46,0,0,1-2.9,2.64c-.58.2-1.28.5-2,.81A14.15,14.15,0,0,1,198.41,354.34Zm-1.28-5.47s-.93.87-.14,3.48a1.22,1.22,0,0,0,.65.84c1.12.53,3.42-.46,5.27-1.26.76-.32,1.47-.63,2.1-.84a3.42,3.42,0,0,0,2.27-2,4.74,4.74,0,0,0-.69-4,1.14,1.14,0,0,0-.81-.53c-2.2-.39-7,3-8.65,4.38Zm-.31-.39h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.13,359.92s8.65-8,10.2-5.26,1.85,5.88-.93,7.73-9.89,6.8-11.44,4S197.13,359.92,197.13,359.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.57,367.74a3.19,3.19,0,0,1-.7-.08,2,2,0,0,1-1.35-1c-1.71-3.07,2.09-6.92,2.25-7.09h0c.7-.65,7-6.42,9.79-5.95a1.61,1.61,0,0,1,1.19.82c2,3.55,1.57,6.61-1.09,8.39l-.41.27C203.78,364.75,199.32,367.74,196.57,367.74Zm.9-7.46c-.15.16-3.39,3.51-2.07,5.89a1,1,0,0,0,.71.52c2.19.52,7.39-2.95,9.6-4.44l.41-.27c3-2,1.77-5.29.77-7.07a.58.58,0,0,0-.46-.32C204.67,354.31,200,357.93,197.47,360.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.74,368s8.66-8,10.21-5.26,1.85,5.88-.93,7.73-9.89,6.8-11.44,4S197.74,368,197.74,368Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.19,375.78a3.13,3.13,0,0,1-.7-.08,2,2,0,0,1-1.35-1c-1.71-3.07,2.09-6.92,2.25-7.09h0c.71-.66,7-6.41,9.8-5.95a1.61,1.61,0,0,1,1.18.82c2,3.55,1.58,6.61-1.08,8.39l-.41.27C204.4,372.79,199.93,375.78,197.19,375.78Zm.9-7.46c-.15.16-3.39,3.51-2.07,5.89a1,1,0,0,0,.71.52c2.18.52,7.38-3,9.6-4.44l.41-.28c3-2,1.76-5.28.77-7.07a.6.6,0,0,0-.47-.31C205.29,362.35,200.63,366,198.09,368.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.9,375.34s6.31-5.86,7.44-3.83,1.35,4.28-.68,5.63-7.21,4.95-8.33,2.93S199.9,375.34,199.9,375.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.5,381.17a2.35,2.35,0,0,1-.54-.06,1.62,1.62,0,0,1-1.07-.8c-1.29-2.33,1.54-5.21,1.66-5.33h0c.85-.79,5.18-4.71,7.25-4.37a1.28,1.28,0,0,1,1,.67c1.46,2.62,1.15,5-.83,6.29l-.3.2C204.81,379,201.54,381.17,199.5,381.17Zm.75-5.47c-.13.13-2.39,2.49-1.49,4.12a.64.64,0,0,0,.43.32c1.54.36,5.29-2.14,6.89-3.21l.3-.21c2.09-1.38,1.22-3.71.52-5a.29.29,0,0,0-.24-.16C205.44,371.41,202.08,374,200.25,375.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 197.2,
    cy: 285.41,
    r: 36.83,
    transform: "translate(-110.35 445.92) rotate(-82.92)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.2,323.74a38.33,38.33,0,1,1,38.33-38.33A38.37,38.37,0,0,1,197.2,323.74Zm0-73.66a35.33,35.33,0,1,0,35.33,35.33A35.36,35.36,0,0,0,197.2,250.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 197.2,
    cy: 285.41,
    r: 24.08,
    transform: "translate(-110.29 446.04) rotate(-82.94)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.2,310a24.58,24.58,0,1,1,24.58-24.58A24.61,24.61,0,0,1,197.2,310Zm0-48.16a23.58,23.58,0,1,0,23.58,23.58A23.61,23.61,0,0,0,197.2,261.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.3,301.17a15.76,15.76,0,0,1,27.5-.52",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.29,301.67a.48.48,0,0,1-.23-.05.51.51,0,0,1-.21-.68,16.27,16.27,0,0,1,28.38-.54.5.5,0,0,1-.17.68.51.51,0,0,1-.69-.17,15.26,15.26,0,0,0-26.63.5A.5.5,0,0,1,183.29,301.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.47,281c0,2.75-.81,5-1.81,5s-1.81-2.23-1.81-5,.81-5,1.81-5S191.47,278.21,191.47,281Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.66,286.44c-1.51,0-2.31-2.76-2.31-5.48s.8-5.47,2.31-5.47S192,278.24,192,281,191.18,286.44,189.66,286.44Zm0-9.95c-.44,0-1.31,1.58-1.31,4.47s.87,4.48,1.31,4.48S191,283.86,191,281,190.11,276.49,189.66,276.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.05,281c0,2.75-.81,5-1.81,5s-1.81-2.23-1.81-5,.81-5,1.81-5S205.05,278.21,205.05,281Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.24,286.44c-1.52,0-2.31-2.76-2.31-5.48s.79-5.47,2.31-5.47,2.31,2.75,2.31,5.47S204.75,286.44,203.24,286.44Zm0-9.95c-.45,0-1.31,1.58-1.31,4.47s.86,4.48,1.31,4.48,1.31-1.58,1.31-4.48S203.68,276.49,203.24,276.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.24,347.6s18-29.65,21.73-38.93,6.5-13.91,11.13-25.66,11.75-20.41,15.77-22.26,8.66-4.33,7.42-.62-5.25,6.8-6.49,8.35,7.63,15.58,6.75,19.69-1.8,9.68-7.37,14.94a84.61,84.61,0,0,1-11.44,9L108.92,397",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.92,397.48a.41.41,0,0,1-.16,0,.5.5,0,0,1-.32-.64l28.83-84.9a.47.47,0,0,1,.2-.26,86.07,86.07,0,0,0,11.37-8.9c5.16-4.88,6.23-10,7.09-14l.13-.65c.45-2.08-2-7.36-4-11.61-2.48-5.33-3.35-7.43-2.66-8.29a21.63,21.63,0,0,1,1.5-1.58c1.7-1.69,4-4,4.91-6.62.24-.72.2-1.08.09-1.18-.58-.51-3.7.95-5.76,1.91l-1.07.5c-4.11,1.9-11,10.64-15.51,22-2.51,6.36-4.46,10.59-6.34,14.69-1.59,3.46-3.09,6.72-4.79,11-3.69,9.21-21.59,38.7-21.77,39a.51.51,0,0,1-.69.17.5.5,0,0,1-.16-.69c.18-.3,18-29.72,21.69-38.85,1.71-4.28,3.22-7.56,4.81-11,1.88-4.08,3.82-8.3,6.32-14.63,4.57-11.59,11.74-20.56,16-22.54l1.07-.49c3.59-1.68,5.85-2.64,6.85-1.75.72.64.32,1.84.19,2.24-1,2.84-3.38,5.25-5.16,7-.6.59-1.11,1.11-1.42,1.49-.29.63,1.49,4.46,2.79,7.25,2.25,4.84,4.57,9.84,4.06,12.24l-.14.64c-.83,4-2,9.46-7.38,14.55a85.64,85.64,0,0,1-11.36,8.93l-28.77,84.74A.51.51,0,0,1,108.92,397.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.85,
    y: 217.33,
    width: 5.28,
    height: 120.44,
    transform: "translate(294.98 555.1) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.13,338.27h-5.28a.5.5,0,0,1-.5-.5V217.33a.51.51,0,0,1,.5-.5h5.28a.5.5,0,0,1,.5.5V337.77A.5.5,0,0,1,150.13,338.27Zm-4.78-1h4.28V217.83h-4.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.68,
    cy: 196.35,
    r: 36.31,
    transform: "translate(-95.59 161.94) rotate(-45)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.68,234.17a37.82,37.82,0,1,1,37.82-37.82A37.86,37.86,0,0,1,147.68,234.17Zm0-72.63a34.82,34.82,0,1,0,34.82,34.81A34.85,34.85,0,0,0,147.68,161.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.17,187.93h-13.9a58.83,58.83,0,0,0,1.8-9.78c.51-5.4-1.29-6.17-5.41-6.17s0,3.6-2,8c-1.65,3.5-6.59,7-8.5,8.26v24.17H160.7c7-1,2.58-5.92,2.58-5.92,5.14-1,2.05-6.17,2.05-6.17,5.15-.78,1.55-5.67,1.55-5.67C172.28,192.05,168.17,187.93,168.17,187.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.11,212.88a.5.5,0,0,1-.5-.5V188.21a.52.52,0,0,1,.23-.42c2-1.3,6.73-4.69,8.31-8a7.52,7.52,0,0,0,.29-4.92c-.2-1.09-.37-2,.17-2.67a2.5,2.5,0,0,1,2-.67c2.23,0,3.92.22,4.93,1.34s1.23,2.68,1,5.38a59.76,59.76,0,0,1-1.65,9.23h13.25a.51.51,0,0,1,.35.15c.08.08,2,2,1.6,4.2a4.46,4.46,0,0,1-2.52,3c.52.85,1.4,2.64.8,4.1a3.12,3.12,0,0,1-2.32,1.73,5.37,5.37,0,0,1,.38,4.19,3.56,3.56,0,0,1-2.33,1.92,4.35,4.35,0,0,1,.85,3.68c-.46,1.27-1.88,2.09-4.21,2.44Zm.5-1H160.7c1.26-.19,2.93-.66,3.34-1.78.51-1.43-1.12-3.28-1.14-3.3a.49.49,0,0,1-.1-.49.52.52,0,0,1,.38-.34,3,3,0,0,0,2.37-1.53c.71-1.6-.63-3.87-.64-3.9a.49.49,0,0,1,0-.47.52.52,0,0,1,.38-.28q1.8-.27,2.22-1.26c.49-1.17-.56-3-1-3.61a.52.52,0,0,1-.09-.42.55.55,0,0,1,.27-.33c1.47-.69,2.3-1.56,2.47-2.56a4.29,4.29,0,0,0-1.18-3.18H154.27a.48.48,0,0,1-.4-.2.46.46,0,0,1-.08-.44,58.11,58.11,0,0,0,1.78-9.69c.23-2.35,0-3.82-.72-4.6s-2.23-1-4.19-1c-.67,0-1.12.1-1.28.3s-.11,1,.05,1.85a8.56,8.56,0,0,1-.37,5.54c-1.63,3.46-6.29,6.86-8.45,8.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.7,
    y: 188.19,
    width: 11.58,
    height: 23.42,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.28,212.11H125.7a.5.5,0,0,1-.5-.5V188.19a.5.5,0,0,1,.5-.5h11.58a.5.5,0,0,1,.5.5v23.42A.5.5,0,0,1,137.28,212.11Zm-11.08-1h10.58V188.69H126.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.72,300.63s8.35-8.65,9-13.6a106.25,106.25,0,0,0,.62-12.37c0-1.85,2.47-14.22,2.47-18.55s-4.33-9.28-5.26-7.11,0,11.44-3.4,16.39-7.73,16.38-8.65,21.95a102.29,102.29,0,0,0-.93,13.6",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.54,301.44a.5.5,0,0,1-.5-.5,104.18,104.18,0,0,1,.93-13.68c.92-5.5,5.22-17,8.74-22.16,2.18-3.17,2.52-8.27,2.77-12a17.34,17.34,0,0,1,.58-4.31,1.27,1.27,0,0,1,1.49-.79c2,.4,4.73,4.56,4.73,8.1,0,2.66-.9,8.19-1.62,12.64-.46,2.8-.85,5.22-.85,5.91a105.89,105.89,0,0,1-.63,12.43c-.63,5.06-8.75,13.53-9.1,13.89a.5.5,0,0,1-.71,0,.51.51,0,0,1,0-.71c.08-.09,8.24-8.6,8.83-13.32a105.35,105.35,0,0,0,.62-12.31c0-.77.38-3.11.86-6.07a108.65,108.65,0,0,0,1.61-12.48c0-3.33-2.67-6.87-3.93-7.12-.17,0-.27,0-.37.21a17.61,17.61,0,0,0-.5,4c-.26,3.84-.61,9.09-2.95,12.49-3.45,5-7.67,16.35-8.57,21.75a102.74,102.74,0,0,0-.92,13.52A.5.5,0,0,1,127.54,301.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.71,259.51s8.35-6.8,10.2-3.71.93,5.88-1.85,6.8-7.73,4-8.66.93S146.71,259.51,146.71,259.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.3,265.37a2.72,2.72,0,0,1-1.19-.24,2.22,2.22,0,0,1-1.19-1.46c-1-3.26.28-4.4.48-4.55.67-.55,6.4-5.12,9.44-4.58a2.08,2.08,0,0,1,1.5,1,5.73,5.73,0,0,1,.77,4.9,4.49,4.49,0,0,1-2.9,2.64c-.58.19-1.27.49-2,.81A14.27,14.27,0,0,1,148.3,265.37ZM147,259.9s-.93.88-.14,3.49a1.25,1.25,0,0,0,.65.84c1.12.52,3.43-.47,5.28-1.26.75-.33,1.46-.63,2.09-.84a3.43,3.43,0,0,0,2.27-2,4.72,4.72,0,0,0-.69-4,1.1,1.1,0,0,0-.81-.54c-2.21-.38-7,3-8.65,4.38Zm-.31-.39h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147,271s8.65-8,10.2-5.25,1.86,5.87-.93,7.73-9.89,6.8-11.44,4S147,271,147,271Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.47,278.77a3.23,3.23,0,0,1-.71-.07,2,2,0,0,1-1.34-1c-1.71-3.08,2.08-6.93,2.24-7.09h0c.7-.66,7-6.4,9.79-5.95a1.58,1.58,0,0,1,1.19.81c2,3.56,1.58,6.61-1.09,8.39l-.41.28C153.67,275.79,149.21,278.77,146.47,278.77Zm.89-7.46c-.15.16-3.39,3.52-2.07,5.89a1,1,0,0,0,.71.52c2.19.53,7.38-3,9.6-4.43L156,273c3-2,1.76-5.28.76-7.07a.6.6,0,0,0-.46-.32C154.56,265.36,149.9,269,147.36,271.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.64,279s8.65-8,10.2-5.26,1.85,5.88-.93,7.73-9.89,6.81-11.44,4S147.64,279,147.64,279Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.08,286.81a3.14,3.14,0,0,1-.7-.07,2.06,2.06,0,0,1-1.35-1c-1.71-3.08,2.09-6.93,2.25-7.09v0c.71-.65,7-6.38,9.8-5.94a1.58,1.58,0,0,1,1.19.81c2,3.56,1.57,6.61-1.09,8.39l-.41.28C154.28,283.83,149.82,286.81,147.08,286.81Zm.9-7.46c-.15.16-3.39,3.52-2.07,5.89a1,1,0,0,0,.71.52c2.18.53,7.38-2.95,9.6-4.43l.41-.28c3-2,1.76-5.29.77-7.07a.58.58,0,0,0-.46-.32C155.19,273.41,150.52,277,148,279.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.8,286.37s6.3-5.86,7.43-3.83,1.35,4.28-.68,5.63-7.2,5-8.33,2.93S149.8,286.37,149.8,286.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.39,292.2a2.35,2.35,0,0,1-.54-.06,1.62,1.62,0,0,1-1.07-.8c-1.29-2.33,1.54-5.2,1.66-5.32l0,0c.84-.78,5.19-4.7,7.25-4.36a1.28,1.28,0,0,1,1,.66c1.45,2.62,1.14,5-.84,6.29l-.3.2C154.7,290,151.43,292.2,149.39,292.2Zm.75-5.47c-.13.13-2.39,2.5-1.48,4.13a.59.59,0,0,0,.43.31c1.53.37,5.28-2.14,6.89-3.21l.3-.2c2.08-1.39,1.21-3.71.51-5a.29.29,0,0,0-.24-.17C155.3,282.43,152,285,150.14,286.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.63,51.54H215.46l-.06.21c-1.69,6.09-5.58,10-9.9,10H203c-4.31,0-8.21-3.95-9.9-10l-.06-.21H135.89a28.83,28.83,0,0,0-28.83,28.83v5.18h194.4V80.37A28.83,28.83,0,0,0,272.63,51.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.46,86.05H107.06a.5.5,0,0,1-.5-.5V80.37A29.37,29.37,0,0,1,135.89,51h57.17a.49.49,0,0,1,.48.37l.06.2c1.63,5.88,5.33,9.68,9.42,9.68h2.48c4.09,0,7.79-3.8,9.42-9.68l.06-.2a.5.5,0,0,1,.48-.37h57.17A29.37,29.37,0,0,1,302,80.37v5.18A.5.5,0,0,1,301.46,86.05Zm-193.9-1H301V80.37A28.36,28.36,0,0,0,272.63,52H215.84c-1.78,6.23-5.82,10.25-10.34,10.25H203c-4.51,0-8.56-4-10.34-10.25H135.89a28.36,28.36,0,0,0-28.33,28.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.83,157.09V120.55h-3.31V73.78A28.83,28.83,0,0,0,281.69,45H126.83A28.83,28.83,0,0,0,98,73.78V388.45a28.83,28.83,0,0,0,28.83,28.83H281.69a28.83,28.83,0,0,0,28.83-28.83V188.22h3.31V166.63h-3.31v-9.54ZM301.46,367.85a28.83,28.83,0,0,1-28.83,28.83H135.89a28.83,28.83,0,0,1-28.83-28.83V80.37a28.83,28.83,0,0,1,28.83-28.83h57.17l.06.21c1.69,6.09,5.59,10,9.9,10h2.48c4.32,0,8.21-3.95,9.9-10l.06-.21h57.17a28.83,28.83,0,0,1,28.83,28.83Z",
    style: {
      fill: "#707070"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.69,417.78H126.83A29.37,29.37,0,0,1,97.5,388.45V73.78a29.37,29.37,0,0,1,29.33-29.33H281.69A29.37,29.37,0,0,1,311,73.78v46.27h2.81a.51.51,0,0,1,.5.5v36.54a.51.51,0,0,1-.5.5H311v8.54h2.81a.51.51,0,0,1,.5.5v21.59a.5.5,0,0,1-.5.5H311V388.45A29.37,29.37,0,0,1,281.69,417.78ZM126.83,45.45A28.36,28.36,0,0,0,98.5,73.78V388.45a28.36,28.36,0,0,0,28.33,28.33H281.69A28.36,28.36,0,0,0,310,388.45V188.22a.51.51,0,0,1,.5-.5h2.81V167.13h-2.81a.5.5,0,0,1-.5-.5v-9.54a.5.5,0,0,1,.5-.5h2.81V121.05h-2.81a.5.5,0,0,1-.5-.5V73.78a28.36,28.36,0,0,0-28.33-28.33Zm145.8,351.73H135.89a29.36,29.36,0,0,1-29.33-29.33V80.37A29.37,29.37,0,0,1,135.89,51h57.17a.49.49,0,0,1,.48.37l.06.2c1.63,5.88,5.33,9.68,9.42,9.68h2.48c4.09,0,7.79-3.8,9.42-9.68l.06-.2a.5.5,0,0,1,.48-.37h57.17A29.37,29.37,0,0,1,302,80.37V367.85A29.36,29.36,0,0,1,272.63,397.18ZM135.89,52a28.36,28.36,0,0,0-28.33,28.33V367.85a28.36,28.36,0,0,0,28.33,28.33H272.63A28.36,28.36,0,0,0,301,367.85V80.37A28.36,28.36,0,0,0,272.63,52H215.84c-1.78,6.23-5.82,10.25-10.34,10.25H203c-4.51,0-8.56-4-10.34-10.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.64,48.92H131.88a30.54,30.54,0,0,0-30.54,30.54v303.3a30.54,30.54,0,0,0,30.54,30.54H276.64a30.54,30.54,0,0,0,30.54-30.54V79.46A30.54,30.54,0,0,0,276.64,48.92Zm24.82,318.93a28.83,28.83,0,0,1-28.83,28.83H135.89a28.83,28.83,0,0,1-28.83-28.83V80.37a28.83,28.83,0,0,1,28.83-28.83h57.17l.06.21c1.69,6.09,5.59,10,9.9,10h2.48c4.32,0,8.21-3.95,9.9-10l.06-.21h57.17a28.83,28.83,0,0,1,28.83,28.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.64,413.8H131.88a31.07,31.07,0,0,1-31-31V79.46a31.08,31.08,0,0,1,31-31H276.64a31.08,31.08,0,0,1,31,31v303.3A31.07,31.07,0,0,1,276.64,413.8ZM131.88,49.42a30.08,30.08,0,0,0-30,30v303.3a30.07,30.07,0,0,0,30,30H276.64a30.07,30.07,0,0,0,30-30V79.46a30.07,30.07,0,0,0-30-30ZM272.63,397.18H135.89a29.36,29.36,0,0,1-29.33-29.33V80.37A29.37,29.37,0,0,1,135.89,51h57.17a.49.49,0,0,1,.48.37l.06.2c1.63,5.88,5.33,9.68,9.42,9.68h2.48c4.09,0,7.79-3.8,9.42-9.68l.06-.2a.5.5,0,0,1,.48-.37h57.17A29.37,29.37,0,0,1,302,80.37V367.85A29.36,29.36,0,0,1,272.63,397.18ZM135.89,52a28.36,28.36,0,0,0-28.33,28.33V367.85a28.36,28.36,0,0,0,28.33,28.33H272.63A28.36,28.36,0,0,0,301,367.85V80.37A28.36,28.36,0,0,0,272.63,52H215.84c-1.78,6.23-5.82,10.25-10.34,10.25H203c-4.51,0-8.56-4-10.34-10.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203.67,
    cy: 52.92,
    r: 2.71,
    style: {
      fill: "#707070"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.34,63.29c0,2.74-3.08,3.73-3.09,5.82v.14h3v.92h-4v-.78c0-2.93,3.08-3.5,3.08-6.06,0-.93-.32-1.42-1.07-1.42s-1.06.53-1.06,1.33v.81h-1v-.74c0-1.39.64-2.31,2-2.31S124.34,61.91,124.34,63.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.31,63.28v.23a1.81,1.81,0,0,1-1.1,1.87,1.82,1.82,0,0,1,1.1,1.88V68c0,1.38-.65,2.29-2,2.29s-2-.91-2-2.29v-.63h1V68c0,.82.34,1.31,1.06,1.31s1.07-.48,1.07-1.4v-.7c0-.9-.38-1.32-1.15-1.35h-.54V65h.6a1.09,1.09,0,0,0,1.09-1.24v-.42c0-.93-.33-1.41-1.07-1.41s-1.06.5-1.06,1.32v.47h-1v-.42c0-1.39.65-2.28,2-2.28S129.31,61.89,129.31,63.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.27,64v1.26h-1V64Zm0,4.94v1.26h-1V68.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.32,64.79a1.46,1.46,0,0,1,1.35-.76c1.17,0,1.69.86,1.69,2.16V68c0,1.38-.66,2.29-2.05,2.29s-2-.91-2-2.29v-.61h.95V68c0,.82.33,1.31,1.06,1.31s1.07-.49,1.07-1.31V66.27c0-.82-.34-1.32-1.07-1.32a1,1,0,0,0-1,1v.21h-.95l.25-5h3.58V62h-2.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.41,63.27v.17h-.95V63.2c0-.81-.34-1.29-1.08-1.29s-1.1.49-1.1,1.46v2a1.47,1.47,0,0,1,1.47-1c1.16,0,1.68.84,1.68,2.15V68c0,1.38-.69,2.29-2.07,2.29s-2.09-.91-2.09-2.29V63.33c0-1.44.65-2.33,2.09-2.33S141.41,61.88,141.41,63.27Zm-3.13,3.4V68c0,.82.34,1.31,1.08,1.31s1.07-.49,1.07-1.31V66.67c0-.82-.35-1.31-1.07-1.31S138.28,65.85,138.28,66.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.01,
    y: 63.67,
    width: 2.56,
    height: 6.41,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.43,
    y: 62.38,
    width: 2.56,
    height: 7.7,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.85,
    y: 61.47,
    width: 2.56,
    height: 8.61,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.27,
    y: 59.88,
    width: 2.56,
    height: 10.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.58,69.9H267.19V60.5h15.39ZM268,69.05h13.68v-7.7H268Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.33,
    y: 62.28,
    width: 8.12,
    height: 5.83,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.05,
    y: 64.09,
    width: 1.94,
    height: 2.22,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.55,67.86a.64.64,0,0,1-.3-.08c-3.13-1.86-5.2-.14-5.29-.06a.57.57,0,0,1-.75-.87c.11-.1,2.76-2.36,6.63-.06a.58.58,0,0,1-.29,1.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.71,65.93a.55.55,0,0,1-.3-.09c-4.53-2.69-7.57-.08-7.6-.06a.57.57,0,0,1-.76-.86s3.71-3.18,8.95-.06a.58.58,0,0,1-.29,1.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.76,63.69a.67.67,0,0,1-.3-.08c-5.73-3.41-9.55-.2-9.7-.06a.59.59,0,0,1-.82-.06.58.58,0,0,1,.06-.81s4.57-3.91,11.05-.06a.58.58,0,0,1-.29,1.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.82,68.82a1.45,1.45,0,1,1-1.45-1.44A1.44,1.44,0,0,1,259.82,68.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.96,
    cy: 125.16,
    r: 26.43,
    transform: "translate(-25.28 35.72) rotate(-13.44)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139,152.09a26.93,26.93,0,1,1,26.93-26.93A27,27,0,0,1,139,152.09Zm0-52.86a25.93,25.93,0,1,0,25.93,25.93A26,26,0,0,0,139,99.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.62,143l-.6,8.27a25.65,25.65,0,0,0,3.94.31,26.23,26.23,0,0,0,14-4c.21-4.55-1-19.8-1-19.8a8.48,8.48,0,0,0,3.92-6.32c.22-4.14-2.61-5.23-2.61-5.23s3.05-10,1.3-12.85-13.94-9.59-24.4-7.41-9.59,9.8-8.94,10.46A44.16,44.16,0,0,0,125,109s.43,14.6,1.09,17.22,4.51,13.71,6,15A9.37,9.37,0,0,0,135.62,143Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139,152.09a27.71,27.71,0,0,1-4-.31.5.5,0,0,1-.43-.53l.58-7.87a9.52,9.52,0,0,1-3.35-1.76c-1.67-1.43-5.58-12.79-6.2-15.27s-1-15-1.09-17.06a35.57,35.57,0,0,1-3.57-2.54c-.52-.52-.72-2.39-.17-4.23.61-2,2.63-5.67,9.36-7.07,10.88-2.27,23.13,4.71,24.93,7.63,1.66,2.71-.53,10.78-1.14,12.87.86.5,2.7,2,2.52,5.51a8.79,8.79,0,0,1-3.9,6.55c.18,2.21,1.19,15.33,1,19.57a.52.52,0,0,1-.24.4A26.8,26.8,0,0,1,139,152.09Zm-3.41-1.24a25.09,25.09,0,0,0,3.41.24,25.84,25.84,0,0,0,13.53-3.82c.16-4.77-1-19.33-1-19.48a.5.5,0,0,1,.24-.47s3.48-2.1,3.68-5.91-2.19-4.7-2.3-4.74a.5.5,0,0,1-.29-.61c.83-2.73,2.69-10.29,1.36-12.45-1.66-2.69-13.6-9.33-23.88-7.18-5.51,1.14-7.61,3.79-8.4,5.81a5.49,5.49,0,0,0-.27,3.82,40.42,40.42,0,0,0,3.61,2.53.51.51,0,0,1,.23.41c0,.14.44,14.57,1.07,17.1.75,3,4.57,13.64,5.88,14.76a9,9,0,0,0,3.33,1.66.49.49,0,0,1,.39.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.18,95.94c-10.46,2.18-9.59,9.8-8.94,10.46a25.9,25.9,0,0,0,2.65,1.91l.62-.17a2.78,2.78,0,0,0,1.31.44c.65,0,2-1.31,2-1.31s4.36,2.39,5.45,2.18,2.83-2.84,4.79-2.84,7.63-.21,6.54,2.4-3.27,3.71-.87,5.23,4.57,1.53,4.79,3.27-1.52,5.88.22,6.1,3.05-3,3.27-4.58a6.57,6.57,0,0,1,1.31-2.83s3.05-10,1.3-12.85S140.64,93.76,130.18,95.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.88,124.12h-.24a1.27,1.27,0,0,1-.89-.51c-.56-.78-.3-2.2,0-3.7a10,10,0,0,0,.26-2.33c-.1-.8-.75-1.1-2.09-1.67a15.45,15.45,0,0,1-2.48-1.24,2.54,2.54,0,0,1-1.28-1.51,3.31,3.31,0,0,1,.88-2.41,11.83,11.83,0,0,0,1.08-1.92.72.72,0,0,0,0-.74c-.67-1-4.29-1-5.65-1H138c-1,0-2,.87-2.89,1.64a4.68,4.68,0,0,1-1.8,1.19c-1.08.21-4.14-1.34-5.47-2.06a4,4,0,0,1-2,1.2,3.1,3.1,0,0,1-1.38-.4l-.42.12a.54.54,0,0,1-.41-.07,23.18,23.18,0,0,1-2.72-2c-.52-.52-.72-2.39-.17-4.23.61-2,2.63-5.67,9.36-7.07,10.88-2.27,23.13,4.71,24.93,7.63s-.94,12.22-1.26,13.27a.56.56,0,0,1-.09.17,6.16,6.16,0,0,0-1.2,2.59C152.27,120.44,151,124.12,148.88,124.12Zm-10-18c2.53,0,5.17.16,6,1.41a1.67,1.67,0,0,1,.09,1.68,11.42,11.42,0,0,1-1.17,2.08c-.46.7-.82,1.25-.73,1.66s.34.56.84.88a15.25,15.25,0,0,0,2.33,1.16c1.35.57,2.51,1.06,2.69,2.47a10.22,10.22,0,0,1-.27,2.63c-.2,1-.46,2.5-.15,2.93a.25.25,0,0,0,.2.11c1.28.16,2.5-2.64,2.71-4.16a6.86,6.86,0,0,1,1.36-3c.84-2.81,2.65-10.22,1.33-12.36-1.66-2.69-13.6-9.33-23.88-7.18-5.51,1.14-7.61,3.79-8.4,5.81a5.49,5.49,0,0,0-.27,3.82,24.61,24.61,0,0,0,2.36,1.71l.41-.11a.49.49,0,0,1,.41.06,2.19,2.19,0,0,0,1,.36,4.78,4.78,0,0,0,1.61-1.17.5.5,0,0,1,.59-.08c2,1.11,4.54,2.25,5.11,2.13a4.74,4.74,0,0,0,1.34-1c1-.84,2.18-1.89,3.55-1.89h.9Zm14.36,10.09h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.62,132h-4.57a.51.51,0,0,1-.5-.49l-.22-9.59a.49.49,0,0,1,.49-.51.48.48,0,0,1,.51.49l.21,9.1h4.08a.5.5,0,0,1,.5.5A.5.5,0,0,1,135.62,132Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.46,123.57c0,.84-.29,1.52-.65,1.52s-.66-.68-.66-1.52.3-1.53.66-1.53S129.46,122.72,129.46,123.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.5,123.44c0,.84-.29,1.53-.65,1.53s-.66-.69-.66-1.53.29-1.53.66-1.53S139.5,122.6,139.5,123.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.18,126.94h-6.57a1.59,1.59,0,0,1-1.59-1.59v-3a1.59,1.59,0,0,1,1.59-1.59h6.57a.51.51,0,0,1,.5.5v5.23A.5.5,0,0,1,130.18,126.94Zm-6.57-5.23a.59.59,0,0,0-.59.59v3a.58.58,0,0,0,.59.59h6.07v-4.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.42,126.94h-7.66a.5.5,0,0,1-.5-.5v-5.23a.5.5,0,0,1,.5-.5h7.66A1.59,1.59,0,0,1,142,122.3v3A1.59,1.59,0,0,1,140.42,126.94Zm-7.16-1h7.16a.59.59,0,0,0,.59-.59v-3a.6.6,0,0,0-.59-.59h-7.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.76,121.71h-2.58a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2.58a.5.5,0,0,1,.5.5A.5.5,0,0,1,132.76,121.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.44,122.8h-8.93a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h8.93a.5.5,0,0,1,.5.5A.5.5,0,0,1,150.44,122.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.42,120.41a.54.54,0,0,1-.3-.1c-2.37-1.78-6-.6-6.08-.58a.5.5,0,0,1-.63-.32.5.5,0,0,1,.31-.63c.17-.06,4.21-1.37,7,.73a.5.5,0,0,1-.3.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.74,120.19a.5.5,0,0,1-.43-.25c0-.06-.69-1-2.81.18a.49.49,0,0,1-.68-.18.5.5,0,0,1,.18-.68,4,4,0,0,1,3-.66,1.9,1.9,0,0,1,1.17.85.51.51,0,0,1-.2.68A.5.5,0,0,1,129.74,120.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.42,143.54a5.87,5.87,0,0,1-4-1.57,5.35,5.35,0,0,1-1-1.35c-1.44-2.88-2.75-5.83-1.56-7.42a2.44,2.44,0,0,1,2.57-.78,19.58,19.58,0,0,0,5.29-.4c.48-.13,1-.31,1.51-.49,1.78-.61,3.47-1.18,4.59-.38a2.09,2.09,0,0,1,.83,1.83,15.88,15.88,0,0,1-2.85,8.05,8.14,8.14,0,0,1-2.27,1.71A6.25,6.25,0,0,1,135.42,143.54Zm-4.74-9.18a.71.71,0,0,0-.27,0c-.13.17-.39,1,1.75,5.32a2.94,2.94,0,0,0,.6.8,4,4,0,0,0,4.74.47,6.27,6.27,0,0,0,1.72-1.24A14.14,14.14,0,0,0,141.6,133a.65.65,0,0,0,0-.25,9.77,9.77,0,0,0-2.75.7c-.55.19-1.11.38-1.62.52a21.38,21.38,0,0,1-6,.46h-.11A2.33,2.33,0,0,0,130.68,134.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.65,136.47a10,10,0,0,1-3.58-.63.5.5,0,0,1-.26-.66.5.5,0,0,1,.65-.26,9.76,9.76,0,0,0,8.9-1.26.5.5,0,1,1,.56.82A11,11,0,0,1,134.65,136.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.62,143a21.67,21.67,0,0,0,8.29-3.27,46.73,46.73,0,0,0,4.35-3.27L135.19,147.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.19,148.3a.46.46,0,0,1-.23-.06.49.49,0,0,1-.27-.49l.44-4.79a.49.49,0,0,1,.42-.45,21.23,21.23,0,0,0,8.07-3.18c2.41-1.71,3.51-2.56,4-3l.34-.29a.5.5,0,0,1,.68.73l-.34.29-12.76,11.07A.52.52,0,0,1,135.19,148.3Zm.9-4.87-.29,3.18,5.63-4.88A23,23,0,0,1,136.09,143.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.73,
    y: 107.05,
    width: 44.54,
    height: 1,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.73,
    y: 114.06,
    width: 73.06,
    height: 1,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.73,
    y: 136.18,
    width: 73.06,
    height: 1,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.73,
    y: 144.38,
    width: 73.06,
    height: 1,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.73,
    y: 152.57,
    width: 73.06,
    height: 1,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.73,
    y: 122.57,
    width: 73.06,
    height: 1,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-53"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "343.24 319.6 343.24 454.78 336.74 454.78 336.74 319.6 332.61 319.6 332.61 459 333.53 459 336.74 459 343.24 459 347.37 459 347.37 454.78 347.37 319.6 343.24 319.6",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.37,459.5H332.61a.5.5,0,0,1-.5-.5V319.6a.5.5,0,0,1,.5-.5h4.13a.5.5,0,0,1,.5.5V454.28h5.5V319.6a.5.5,0,0,1,.5-.5h4.13a.5.5,0,0,1,.5.5V459A.5.5,0,0,1,347.37,459.5Zm-14.26-1h13.76V320.1h-3.13V454.78a.51.51,0,0,1-.5.5h-6.5a.5.5,0,0,1-.5-.5V320.1h-3.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "465.51 319.6 465.51 454.78 459.6 454.78 459.6 319.6 455.46 319.6 455.46 459 455.49 459 459.6 459 465.51 459 469.33 459 469.64 459 469.64 319.6 465.51 319.6",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.64,459.5H455.49a.53.53,0,0,1-.53-.5V319.6a.51.51,0,0,1,.5-.5h4.14a.5.5,0,0,1,.5.5V454.28H465V319.6a.5.5,0,0,1,.5-.5h4.13a.5.5,0,0,1,.5.5V459A.5.5,0,0,1,469.64,459.5Zm-13.68-1h13.18V320.1H466V454.78a.51.51,0,0,1-.5.5H459.6a.5.5,0,0,1-.5-.5V320.1H456Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.74,
    y: 276.48,
    width: 128.77,
    height: 93.33,
    rx: 5.02,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.49,370.31H341.76a5.53,5.53,0,0,1-5.52-5.52V281.5a5.53,5.53,0,0,1,5.52-5.52H460.49A5.53,5.53,0,0,1,466,281.5v83.29A5.53,5.53,0,0,1,460.49,370.31ZM341.76,277a4.53,4.53,0,0,0-4.52,4.52v83.29a4.53,4.53,0,0,0,4.52,4.52H460.49a4.53,4.53,0,0,0,4.52-4.52V281.5a4.53,4.53,0,0,0-4.52-4.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.21,389.76H336.44a2.65,2.65,0,0,1-2.65-2.65V368.2a2.65,2.65,0,0,1,2.65-2.65L397,368.24q6.92.3,13.82,0l54.4-2.66a2.66,2.66,0,0,1,2.66,2.65v18.91A2.66,2.66,0,0,1,465.21,389.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.21,390.26H336.45a3.15,3.15,0,0,1-3.16-3.15v-18.9a3.15,3.15,0,0,1,3.16-3.16L397,367.74c4.56.2,9.19.19,13.77,0l54.4-2.66h0a3.16,3.16,0,0,1,3.18,3.16v18.9A3.16,3.16,0,0,1,465.21,390.26ZM336.42,366.05a2.14,2.14,0,0,0-2.13,2.16v18.9a2.15,2.15,0,0,0,2.16,2.15H465.21a2.16,2.16,0,0,0,2.16-2.15v-18.9a2.16,2.16,0,0,0-2.16-2.16l-54.37,2.66c-4.61.22-9.27.23-13.87,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.19,327.53l1.67,38.67s28.66,4.33,47,.67,10-32,9.66-35a9.43,9.43,0,0,0-1.33-4.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.85,368.83a223.83,223.83,0,0,1-29.07-2.13.5.5,0,0,1-.42-.48l-1.67-38.66a.47.47,0,0,1,.14-.37.48.48,0,0,1,.36-.16h57a.51.51,0,0,1,.4.2,9.86,9.86,0,0,1,1.43,4.58c0,.31.17,1,.35,1.82,1.12,5.34,4.11,19.55-1.37,27.85a13.56,13.56,0,0,1-9.05,5.88A95.35,95.35,0,0,1,406.85,368.83Zm-28.51-3.06c3.56.5,29.56,4,46.42.61a12.62,12.62,0,0,0,8.41-5.45c5.24-8,2.32-21.86,1.22-27.1-.19-.9-.32-1.55-.36-1.91a10.18,10.18,0,0,0-1.12-3.89h-56.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "386.54 330.17 419.45 330.17 418.15 251.64 415.82 249.83 395.35 252.16 394.83 253.72 386.54 330.17",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.45,330.67H386.54a.51.51,0,0,1-.5-.56l8.29-76.45a.38.38,0,0,1,0-.1l.51-1.56a.53.53,0,0,1,.42-.34l20.47-2.33a.49.49,0,0,1,.37.1l2.33,1.82a.47.47,0,0,1,.19.38l1.3,78.53a.54.54,0,0,1-.14.36A.55.55,0,0,1,419.45,330.67Zm-32.36-1h31.85l-1.28-77.78-2-1.54-19.95,2.27-.4,1.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.87,251.12l-1.3,7.52-3.89,71.27H366.32l-7.77-18.66s6.22-44.06,9.07-47.95S395.87,251.12,395.87,251.12Z",
    style: {
      fill: "#DE0EEA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.68,330.41H366.32a.5.5,0,0,1-.46-.31l-7.77-18.66a.46.46,0,0,1,0-.26c.26-1.81,6.27-44.23,9.16-48.17s27.46-12,28.5-12.36a.49.49,0,0,1,.48.1.48.48,0,0,1,.17.46l-1.3,7.51-3.88,71.21A.5.5,0,0,1,390.68,330.41Zm-24-1h23.55l3.86-70.8,1.16-6.75c-7.53,2.5-25,8.77-27.21,11.74s-6.8,32.35-9,47.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.57,258.64l1.3-7.52s-4.18,1.37-9.34,3.25c-.83,5.74-2.16,18.13-.25,29.41,1.59,9.39,4,19,5.56,25Z",
    style: {
      fill: "#DE0EEA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.84,309.25a.5.5,0,0,1-.49-.37c-1.67-6.29-4-15.74-5.57-25-1.89-11.16-.65-23.31.25-29.56a.5.5,0,0,1,.33-.4c5.1-1.86,9.31-3.24,9.35-3.25a.49.49,0,0,1,.48.1.48.48,0,0,1,.17.46l-1.29,7.49-2.73,50.08a.52.52,0,0,1-.45.47ZM387,254.74c-.89,6.27-2.05,18.1-.21,28.95,1.33,7.82,3.19,15.77,4.74,21.84l2.56-46.92a.13.13,0,0,1,0-.06l1.15-6.69C393.82,252.33,390.65,253.4,387,254.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.54,282.72h-.05a.5.5,0,0,1-.45-.55l.52-5.18a.51.51,0,0,1,.55-.45.5.5,0,0,1,.45.55l-.52,5.18A.51.51,0,0,1,372.54,282.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.17,316.15h-.05a.5.5,0,0,1-.44-.55l2.82-28a.51.51,0,0,1,.55-.44.49.49,0,0,1,.44.54l-2.82,28A.49.49,0,0,1,369.17,316.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.65,207.59s.52,17.36,1.3,20.47,5.36,16.3,7.17,17.86a11.13,11.13,0,0,0,4.23,2.09l-.78,10.63s4.15,7,8.81,7,11.66-8.56,12.44-10.89-1-24.88-1-24.88,4.41-2.59,4.67-7.51-3.11-6.22-3.11-6.22,3.63-11.92,1.55-15.29-16.58-11.4-29-8.81-11.4,11.66-10.63,12.44A52.82,52.82,0,0,0,382.65,207.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.38,266.14c-4.89,0-9.06-6.95-9.24-7.25a.47.47,0,0,1-.07-.29l.75-10.21a11.25,11.25,0,0,1-4-2.09c-2-1.69-6.6-15.17-7.34-18.12s-1.23-18.05-1.3-20.32a43.46,43.46,0,0,1-4.27-3c-.53-.53-.85-2.66-.18-4.93s3.11-6.7,11.06-8.35c12.91-2.69,27.42,5.57,29.55,9,2,3.19-.75,13.12-1.38,15.29,1,.55,3.23,2.29,3,6.5a10.4,10.4,0,0,1-4.64,7.75c.27,3.39,1.75,22.5,1,24.78C415.43,257.5,408.22,266.14,403.38,266.14Zm-8.3-7.63c.59.95,4.32,6.63,8.3,6.63,4.26,0,11.2-8.25,12-10.55.54-1.64-.34-15.65-1.06-24.68a.5.5,0,0,1,.24-.47s4.18-2.52,4.42-7.11-2.76-5.71-2.79-5.73a.51.51,0,0,1-.3-.61c1-3.25,3.21-12.27,1.61-14.88-2-3.21-16.23-11.14-28.5-8.58-6.71,1.39-9.21,4.65-10.13,7.14a6.37,6.37,0,0,0-.23,4.46,47.35,47.35,0,0,0,4.31,3,.49.49,0,0,1,.23.4c0,.17.52,17.35,1.28,20.37.8,3.2,5.34,16.16,7,17.6a10.7,10.7,0,0,0,4,2,.5.5,0,0,1,.39.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.87,192c-12.44,2.59-11.4,11.66-10.63,12.44a32.12,32.12,0,0,0,3.15,2.28l.74-.21a3.3,3.3,0,0,0,1.56.52c.77,0,2.33-1.56,2.33-1.56s5.18,2.85,6.48,2.59,3.37-3.36,5.7-3.36,9.07-.26,7.77,2.85-3.88,4.4-1,6.22,5.44,1.81,5.7,3.88-1.82,7,.26,7.26,3.63-3.63,3.88-5.44a7.72,7.72,0,0,1,1.56-3.37s3.63-11.92,1.55-15.29S401.31,189.45,388.87,192Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.1,225.46h-.26a1.42,1.42,0,0,1-1-.57c-.65-.89-.35-2.56,0-4.33a11.61,11.61,0,0,0,.31-2.79c-.12-1-.91-1.38-2.53-2.06a19.6,19.6,0,0,1-2.94-1.47,2.94,2.94,0,0,1-1.48-1.75c-.2-.93.37-1.79,1-2.79a13.65,13.65,0,0,0,1.29-2.3.93.93,0,0,0,0-1c-.83-1.24-5-1.2-6.8-1.2h-.51c-1.23,0-2.44,1-3.51,2a5.41,5.41,0,0,1-2.1,1.38c-1.25.25-5.13-1.73-6.49-2.46a4.86,4.86,0,0,1-2.41,1.44,3.5,3.5,0,0,1-1.63-.48l-.54.15a.5.5,0,0,1-.41-.07,26.8,26.8,0,0,1-3.22-2.34c-.53-.53-.85-2.66-.18-4.93s3.11-6.7,11.06-8.35h0c12.91-2.69,27.42,5.57,29.55,9s-1.35,15.2-1.5,15.69a.4.4,0,0,1-.1.18,7.23,7.23,0,0,0-1.44,3.12C415,221.37,413.47,225.46,411.1,225.46Zm-11.82-21.23c3,0,6.08.18,7.06,1.64a1.94,1.94,0,0,1,.1,1.91,14.67,14.67,0,0,1-1.39,2.46c-.55.85-1,1.51-.88,2,.07.35.41.72,1,1.11a16.79,16.79,0,0,0,2.79,1.39c1.57.67,2.93,1.24,3.13,2.86a11.1,11.1,0,0,1-.32,3.1c-.24,1.35-.55,3-.15,3.56a.37.37,0,0,0,.3.16c1.53.19,3.07-3.18,3.33-5a8.15,8.15,0,0,1,1.6-3.54c1-3.33,3.17-12.21,1.58-14.79-2-3.21-16.23-11.14-28.5-8.58h0c-6.71,1.39-9.21,4.65-10.13,7.14a6.37,6.37,0,0,0-.23,4.46,26.18,26.18,0,0,0,2.86,2.08l.53-.14a.49.49,0,0,1,.41.06,2.64,2.64,0,0,0,1.28.44,5.48,5.48,0,0,0,2-1.41.5.5,0,0,1,.59-.09c2.47,1.36,5.42,2.68,6.14,2.54a5.37,5.37,0,0,0,1.64-1.16c1.14-1,2.56-2.21,4.16-2.21h1.08ZM388.87,192h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.35,234.78h-5.44a.49.49,0,0,1-.5-.49l-.26-11.4a.49.49,0,0,1,.48-.51.5.5,0,0,1,.52.49l.24,10.91h5a.5.5,0,0,1,0,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.31,225c0,1-.34,1.81-.77,1.81s-.78-.81-.78-1.81.35-1.81.78-1.81S387.31,224,387.31,225Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.68,224.69c0,1-.35,1.81-.78,1.81s-.77-.81-.77-1.81.34-1.81.77-1.81S397.68,223.69,397.68,224.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.87,228.82h-7.81a1.81,1.81,0,0,1-1.8-1.8v-3.63a1.8,1.8,0,0,1,1.8-1.79h7.81a.5.5,0,0,1,.5.5v6.22A.5.5,0,0,1,388.87,228.82Zm-7.81-6.22a.8.8,0,0,0-.8.79V227a.8.8,0,0,0,.8.8h7.31V222.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.05,228.82h-9.11a.51.51,0,0,1-.5-.5V222.1a.5.5,0,0,1,.5-.5h9.11a1.8,1.8,0,0,1,1.8,1.79V227A1.81,1.81,0,0,1,401.05,228.82Zm-8.61-1h8.61a.8.8,0,0,0,.8-.8v-3.63a.8.8,0,0,0-.8-.79h-8.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.94,222.6h-3.07a.5.5,0,0,1,0-1h3.07a.5.5,0,0,1,0,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413,223.89H402.35a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5H413a.5.5,0,0,1,.5.5A.5.5,0,0,1,413,223.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.05,221a.49.49,0,0,1-.3-.1c-2.86-2.14-7.27-.71-7.32-.7a.5.5,0,1,1-.31-1c.2-.07,4.95-1.61,8.23.85a.5.5,0,0,1,.1.7A.48.48,0,0,1,401.05,221Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.35,220.78a.5.5,0,0,1-.43-.25c-.05-.07-.85-1.32-3.47.19a.51.51,0,0,1-.68-.19.49.49,0,0,1,.18-.68,4.68,4.68,0,0,1,3.51-.77,2.22,2.22,0,0,1,1.33,1,.5.5,0,0,1-.44.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.1,248.46a6.76,6.76,0,0,1-4.67-1.82,5.67,5.67,0,0,1-1.16-1.55c-1.61-3.22-3.22-6.82-1.88-8.62a2.77,2.77,0,0,1,2.89-.85,23.65,23.65,0,0,0,6.36-.49c.57-.16,1.19-.37,1.81-.58,2.07-.71,4-1.38,5.29-.48a2.31,2.31,0,0,1,.9,2,18.63,18.63,0,0,1-3.34,9.45,9.5,9.5,0,0,1-2.64,2A7.25,7.25,0,0,1,395.1,248.46Zm-5.63-10.91c-.26,0-.42,0-.47.12-.27.36-.36,1.68,2.06,6.53a3.63,3.63,0,0,0,.76,1,5,5,0,0,0,5.86.59,7.2,7.2,0,0,0,2.08-1.53,17,17,0,0,0,2.88-8.17.72.72,0,0,0-.07-.4c-.37-.31-2.47.41-3.48.75-.66.23-1.31.45-1.92.62a25.54,25.54,0,0,1-7.07.55H390A2.59,2.59,0,0,0,389.47,237.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.19,240.15a11.26,11.26,0,0,1-4.22-.75.49.49,0,0,1-.26-.65.5.5,0,0,1,.65-.27A11.84,11.84,0,0,0,401,237a.5.5,0,0,1,.56.82A13,13,0,0,1,394.19,240.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.35,248a25.53,25.53,0,0,0,9.85-3.88,55.11,55.11,0,0,0,5.18-3.89l-15.55,13.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.83,254.22a.46.46,0,0,1-.23-.06.5.5,0,0,1-.27-.49l.52-5.7a.5.5,0,0,1,.43-.45,25.33,25.33,0,0,0,9.63-3.8c2.88-2,4.19-3.06,4.74-3.51l.4-.35a.51.51,0,0,1,.7,0,.5.5,0,0,1,0,.69s-.11.11-.4.35l-15.17,13.15A.53.53,0,0,1,394.83,254.22Zm1-5.78-.37,4.09,7.41-6.43A26.79,26.79,0,0,1,395.81,248.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.82,249.83l-1.29,79.3,23.84.52,3.37-12.7,17.88-1s-6.22-32.13-8.55-41.2-2.34-11.15-6-14.26S415.82,249.83,415.82,249.83Z",
    style: {
      fill: "#DE0EEA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.37,330.15h0l-23.85-.52a.49.49,0,0,1-.48-.51l1.29-79.3a.49.49,0,0,1,.2-.39.5.5,0,0,1,.44-.08c1.05.31,25.8,7.58,29.47,10.72,3.2,2.75,3.7,4.79,5.2,10.84.27,1.08.57,2.3.92,3.67,2.31,9,8.5,40.92,8.56,41.24a.48.48,0,0,1-.1.4.52.52,0,0,1-.36.19l-17.52,1-3.28,12.35A.5.5,0,0,1,438.37,330.15ZM415,328.64l23,.5,3.26-12.32a.5.5,0,0,1,.46-.37l17.31-1c-.84-4.33-6.31-32.32-8.44-40.62-.35-1.38-.65-2.59-.92-3.68-1.48-6-1.92-7.78-4.88-10.32-3.19-2.73-24.51-9.16-28.47-10.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415,303.36a90.6,90.6,0,0,0,6.57-12.59c3.33-7.76,2.86-31.68,2.66-38.39-4.73-1.49-8.36-2.55-8.36-2.55Z",
    style: {
      fill: "#DE0EEA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415,303.86l-.15,0a.5.5,0,0,1-.35-.49l.87-53.53a.49.49,0,0,1,.2-.39.5.5,0,0,1,.44-.08s3.69,1.08,8.37,2.56a.51.51,0,0,1,.35.46c.21,7.08.65,30.78-2.7,38.6a90.42,90.42,0,0,1-6.61,12.65A.5.5,0,0,1,415,303.86Zm1.36-53.37-.83,51.05a91.12,91.12,0,0,0,5.58-11c3.22-7.51,2.84-30.39,2.63-37.83C420.31,251.69,417.51,250.85,416.31,250.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.79,274.76a.49.49,0,0,1-.5-.47l-.27-4.74a.49.49,0,0,1,.47-.52.47.47,0,0,1,.53.47l.26,4.73a.49.49,0,0,1-.47.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.11,315.89a.49.49,0,0,1-.5-.47l-2-35.68a.5.5,0,0,1,.47-.52.47.47,0,0,1,.53.47l2,35.68a.5.5,0,0,1-.47.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.17,314.41s3.49-3.05,6.11-3.56,10.91.28,14.44,1,5.84,5.66,7.19,9.13-.2,9.55-3,11.1-8.12,1.9-8.12,1.9Z",
    style: {
      fill: "#DE0EEA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.83,334.44a.49.49,0,0,1-.38-.18l-16.66-19.53a.5.5,0,0,1,0-.7c.15-.13,3.62-3.14,6.34-3.67s11.28.31,14.63.95c3.78.73,6.13,5.74,7.57,9.45s-.28,10.08-3.18,11.71-8.11,1.95-8.33,2Zm-15.95-20,16.17,18.95c1.07-.09,5.36-.53,7.66-1.82,2.5-1.41,4-7.18,2.73-10.48-2.12-5.46-4.35-8.35-6.82-8.82-3.61-.7-11.77-1.43-14.25-1C440.4,311.72,437.83,313.69,436.88,314.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.09,318.82c-3-3.71-31.67-5.9-31.67-5.9-5.62-.49-11-.94-11.7-.94-1.64,0-16.17,11.23-18.08,12.06-.44.18-.59.45-.56.78l-4.1,5.79,10.3-.84c3.14.79,7.68-1.18,8.88-1.9,1.37-.82,6-5.48,6-5.48l21.12,9a14.31,14.31,0,0,0,1.39,1.14c2.73,1.85,11.21,3.61,15.61,1.74S462.65,323.22,459.09,318.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.42,335.59c-4.21,0-8.93-1.22-11-2.63a13.87,13.87,0,0,1-1.38-1.12L418.3,323a60.81,60.81,0,0,1-5.89,5.32c-1,.59-5.7,2.79-9.17,2l-10.22.83a.51.51,0,0,1-.48-.25.52.52,0,0,1,0-.54l4-5.66a1.25,1.25,0,0,1,.86-1.08c.73-.32,3.67-2.43,6.78-4.66,7.31-5.25,10.52-7.44,11.5-7.44.64,0,4.59.32,11.74.94,3,.23,29,2.32,32,6.08h0c1.87,2.32,2.46,6.11,1.52,9.88-.78,3.12-2.47,5.51-4.51,6.37A13.34,13.34,0,0,1,451.42,335.59Zm-33.24-13.7a.65.65,0,0,1,.2,0l21.12,9a.55.55,0,0,1,.14.09,13,13,0,0,0,1.33,1.09c2.78,1.88,11,3.45,15.13,1.7,1.75-.74,3.22-2.87,3.93-5.69.85-3.42.33-7-1.33-9-2.35-2.9-23.4-5.11-31.32-5.71-8.87-.78-11.24-.94-11.66-.94-.92.08-6.93,4.39-10.91,7.25a78.25,78.25,0,0,1-7,4.77c-.27.11-.26.2-.25.27a.52.52,0,0,1-.09.34L394,330l9.23-.76a.41.41,0,0,1,.16,0c2.92.73,7.25-1.1,8.5-1.85a64.63,64.63,0,0,0,5.93-5.4A.49.49,0,0,1,418.18,321.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.86,363.2s-1.67-2.33-4-8.67,6.33-41.33,6.33-41.33l26-9.33a107,107,0,0,1,4,23.66c.67,13,1,30-3,34.67s-21.67,6-26.67,5",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.91,368a25.23,25.23,0,0,1-4.49-.31.5.5,0,1,1,.2-1c5.13,1,22.4-.42,26.19-4.83,3.92-4.58,3.52-21.78,2.88-34.32a108.36,108.36,0,0,0-3.83-23l-25.25,9.06c-.78,3.21-8.44,34.95-6.28,40.78a41.94,41.94,0,0,0,3.93,8.55.5.5,0,1,1-.81.58c-.07-.1-1.73-2.46-4.06-8.78s6-40.19,6.31-41.63a.51.51,0,0,1,.32-.35l26-9.33a.48.48,0,0,1,.39,0,.51.51,0,0,1,.26.3,108.53,108.53,0,0,1,4,23.79c.65,12.71,1,30.17-3.12,35C436.2,366.46,424.15,368,416.91,368Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "337.52 253.87 346.86 280.2 358.86 278.2 350.52 251.2 337.52 253.87",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.86,280.7a.52.52,0,0,1-.48-.33L337.05,254a.5.5,0,0,1,0-.41.51.51,0,0,1,.33-.24l13-2.67a.51.51,0,0,1,.58.34l8.33,27a.5.5,0,0,1-.39.64l-12,2Zm-8.67-26.46,9,25.4,11-1.84-8-26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343,270.87s-6.64-7.75-4.7-8.58,5.53-2.49,7.2-1.39a3.29,3.29,0,0,1,1.38,3.05l-4.15.27,2.77,5.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343,271.37a.49.49,0,0,1-.38-.18c-.93-1.09-5.6-6.66-5.14-8.61a1,1,0,0,1,.62-.75l.34-.15c2.21-.95,5.54-2.39,7.33-1.19a3.75,3.75,0,0,1,1.6,3.53.5.5,0,0,1-.46.43l-3.41.22,2.45,5.15a.53.53,0,0,1,0,.41.48.48,0,0,1-.31.28l-2.49.83A.41.41,0,0,1,343,271.37ZM344,261a15.82,15.82,0,0,0-5.21,1.57l-.34.15c-.29,1.09,2.5,5,4.67,7.54l1.63-.55-2.52-5.3a.49.49,0,0,1,.41-.71l3.71-.25a2.71,2.71,0,0,0-1.18-2.16A2.14,2.14,0,0,0,344,261Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.84,264.55s-13,4.28-12.62,5.5,8.95,19.54,8.95,19.54L350.41,325l16.08-7.94-13.64-28.9s.62-3.26-.4-4.89a40,40,0,0,1-2-3.87s5.7-1.22,5.7-2.24S351.84,264.55,351.84,264.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.41,325.51a.47.47,0,0,1-.25-.07.5.5,0,0,1-.25-.4l-2.23-35.32c-.71-1.53-8.54-18.31-8.94-19.51a.74.74,0,0,1,.05-.57c.75-1.48,10.06-4.63,12.89-5.56a.5.5,0,0,1,.63.3c.72,1.95,4.3,11.74,4.3,12.79,0,.9-1.84,1.77-5.48,2.6.37.76,1.06,2.15,1.74,3.25,1,1.57.62,4.36.5,5.07l13.57,28.77a.49.49,0,0,1-.23.66l-16.08,7.94A.54.54,0,0,1,350.41,325.51ZM339.74,270c.64,1.62,6,13.24,8.89,19.36a.53.53,0,0,1,0,.18l2.19,34.67,15-7.39L352.4,288.38a.55.55,0,0,1,0-.31c.16-.85.41-3.33-.34-4.53a39.18,39.18,0,0,1-2.06-3.92.47.47,0,0,1,0-.43.49.49,0,0,1,.34-.27c2.63-.56,5.07-1.4,5.32-1.83-.05-.65-2.47-7.47-4.1-11.91C346.14,267,340.48,269.19,339.74,270Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.07,273.6a.5.5,0,0,1-.47-.31.5.5,0,0,1,.28-.65l10.78-4.48a.51.51,0,0,1,.66.27.52.52,0,0,1-.27.66l-10.79,4.47A.43.43,0,0,1,342.07,273.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.31,277.67a.51.51,0,0,1-.47-.31.51.51,0,0,1,.28-.65l9.77-3.87a.5.5,0,1,1,.37.93l-9.77,3.87A.57.57,0,0,1,344.31,277.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.92,313.84s-3.88-23.32-9.33-24.36-83.19,31.62-88.37,33.43S332.11,326,332.11,326s-10.62-1.81-16.32-4.92-9.07-7.26-11.15-2.34,3.11,15.81,6.22,17.89,11.67,8,14,9.07,14-5.45,18.14-7.52,42.5-13,56-15.29,25.91-5.18,31.61-9.33",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.5,346.32a2,2,0,0,1-.84-.15c-1.88-.83-7.41-4.59-11.46-7.34l-2.61-1.77c-3.22-2.14-8.59-13.31-6.41-18.49a3.86,3.86,0,0,1,2.23-2.47c1.64-.51,3.55.75,6,2.32,1.09.71,2.31,1.51,3.65,2.24,5.26,2.87,14.94,4.65,16.06,4.85.74-.2,5.28-1.43,10-3.07,1.19-.42,6.35-2.52,13.49-5.43,36.78-15,71.31-28.76,75.14-28,5.62,1.07,9.32,22.34,9.73,24.77a.5.5,0,0,1-1,.16c-1.07-6.39-4.75-23.15-8.93-23.95-4-.77-51.68,18.64-74.58,28-7.15,2.91-12.32,5-13.53,5.44-5.15,1.8-10.1,3.11-10.15,3.12a.38.38,0,0,1-.21,0c-.44-.07-10.77-1.86-16.48-5-1.37-.74-2.61-1.55-3.71-2.27-2.21-1.43-3.95-2.57-5.13-2.2-.62.19-1.15.81-1.61,1.9-2,4.71,3.11,15.31,6,17.27.67.44,1.58,1.06,2.63,1.77,3.78,2.58,9.5,6.46,11.29,7.26s10.86-4,15.24-6.23c1-.51,1.82-.95,2.48-1.28,4.17-2.08,42.47-13,56.11-15.33,11.43-2,25.32-4.82,31.41-9.24a.5.5,0,1,1,.59.8c-6.25,4.55-20.29,7.43-31.83,9.42-13.59,2.35-51.69,13.18-55.84,15.25l-2.46,1.26C334.24,343.3,328.18,346.32,325.5,346.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.09,337.37l-4.84-13.79c-4.39,1.45-8.14,2.44-8.14,2.44s-10.62-1.81-16.32-4.92-9.07-7.26-11.15-2.34,3.11,15.81,6.22,17.89,11.67,8,14,9.07,14-5.45,18.14-7.52C343.4,338,344.12,337.72,345.09,337.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.5,346.32a2,2,0,0,1-.84-.15c-1.88-.83-7.41-4.59-11.46-7.34l-2.61-1.77c-3.22-2.14-8.59-13.31-6.41-18.49a3.86,3.86,0,0,1,2.23-2.47c1.64-.5,3.55.75,6,2.32,1.09.71,2.31,1.51,3.65,2.24,5.26,2.87,14.94,4.65,16.06,4.85.64-.17,4.08-1.11,8-2.41a.52.52,0,0,1,.63.31l4.83,13.8a.49.49,0,0,1-.3.63,20.07,20.07,0,0,0-2,.81l-2.46,1.26C334.24,343.3,328.18,346.32,325.5,346.32ZM307.19,317a1.51,1.51,0,0,0-.48.07c-.62.19-1.15.81-1.61,1.9-2,4.71,3.11,15.31,6,17.27.67.44,1.58,1.06,2.63,1.77,3.78,2.58,9.5,6.46,11.29,7.26s10.86-4,15.24-6.23c1-.51,1.82-.95,2.48-1.28.34-.17.89-.39,1.68-.68L340,324.21c-4.16,1.36-7.67,2.28-7.71,2.29a.38.38,0,0,1-.21,0c-.44-.07-10.77-1.86-16.48-5-1.37-.74-2.62-1.55-3.71-2.27C309.92,318,308.35,317,307.19,317Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.64,318.76c-2.07,4.93,3.11,15.81,6.22,17.89s11.67,8,14,9.07c1.79.79,9.09-2.85,14.26-5.52l-3.64-4.85a50.77,50.77,0,0,0,1.56-6c.52-2.85-4.93-3.37-4.93-3.37s-10.62-1.81-16.32-4.92S306.72,313.84,304.64,318.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.51,346.32a2.09,2.09,0,0,1-.85-.15c-1.88-.83-7.41-4.59-11.46-7.34l-2.61-1.77c-3.22-2.14-8.59-13.31-6.41-18.49h0a3.86,3.86,0,0,1,2.23-2.47c1.64-.5,3.55.75,6,2.32,1.09.71,2.31,1.51,3.65,2.24,5.56,3,16.06,4.85,16.17,4.87s3.6.36,4.88,2.06a2.29,2.29,0,0,1,.45,1.89,49.54,49.54,0,0,1-1.49,5.78l3.48,4.64a.51.51,0,0,1,.09.41.48.48,0,0,1-.26.33C332.78,344,327.84,346.32,325.51,346.32ZM305.1,319c-2,4.71,3.11,15.31,6,17.27.67.44,1.58,1.06,2.63,1.77,3.78,2.58,9.5,6.46,11.29,7.26,1.62.71,9.89-3.47,13.31-5.23l-3.29-4.38a.53.53,0,0,1-.07-.46,51.48,51.48,0,0,0,1.54-5.89,1.37,1.37,0,0,0-.26-1.11c-.85-1.12-3.34-1.59-4.22-1.67-.48-.08-10.81-1.87-16.52-5-1.37-.74-2.62-1.55-3.71-2.27-2.21-1.43-3.94-2.57-5.13-2.2-.62.19-1.15.81-1.61,1.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.35,345.81h.19a2.9,2.9,0,0,0,.48,0l.23,0c.21,0,.44-.08.69-.14l.13,0c.3-.08.63-.18,1-.29l.14-.05c-1.9-1.29-11.9-8.21-17.05-14.3-4.14-4.89-4.45-11.27-4.31-14.4-.85.14-1.56.79-2.17,2.22-2.07,4.93,3.11,15.81,6.22,17.89s11.67,8,14,9.07A1.65,1.65,0,0,0,325.35,345.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.43,346.32h-.11a1.86,1.86,0,0,1-.66-.14c-1.88-.83-7.41-4.59-11.46-7.34l-2.61-1.77c-3.22-2.14-8.59-13.31-6.41-18.49.64-1.51,1.47-2.34,2.54-2.53a.53.53,0,0,1,.42.12.51.51,0,0,1,.17.4c-.14,3.23.21,9.36,4.19,14.06,5.11,6,15,12.89,16.95,14.21a.49.49,0,0,1,.21.47.49.49,0,0,1-.32.41l-.14.05c-.36.12-.69.22-1,.3l-.1,0c-.3.08-.54.13-.77.17l-.19,0A5.85,5.85,0,0,1,325.43,346.32Zm1.39-1.2.25.46-.12-.49.08,0c-3.12-2.17-11.64-8.31-16.29-13.8-3.9-4.62-4.51-10.48-4.45-14A3.62,3.62,0,0,0,305.1,319c-2,4.71,3.11,15.31,6,17.27.67.44,1.58,1.06,2.63,1.77,3.78,2.58,9.5,6.46,11.29,7.26a1.14,1.14,0,0,0,.32.06h.09a3.58,3.58,0,0,0,.49,0l.21,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.27,459a24.37,24.37,0,0,0,.59-5.8c0-3.33-2-20.33-1.67-23.33s13-81,13-81l13.67,2s-5-18.34-10.67-24.67-21-6.33-27-3.67-6.67,18.67-6,33.34,2.33,78.33,2.33,78.33-6.33,15.33-8.33,19.33c-1.49,3-2.8,4.49-2.53,5.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.27,459.5H347.66a.5.5,0,0,1-.49-.37c-.22-.85.3-1.75,1.16-3.25.43-.72.9-1.55,1.41-2.57,1.89-3.77,7.73-17.88,8.28-19.2-.08-2.95-1.68-64-2.33-78.22-.92-20.17,1.2-31.55,6.3-33.81,5.92-2.63,21.64-2.84,27.57,3.79,5.68,6.35,10.57,24.11,10.78,24.87a.52.52,0,0,1-.11.46.5.5,0,0,1-.45.16l-13.18-1.93c-1.07,6.61-12.6,77.66-12.91,80.49-.19,1.71.41,8.23.94,14,.39,4.23.73,7.88.73,9.29a25,25,0,0,1-.61,5.94A.5.5,0,0,1,374.27,459.5Zm-26.12-1h25.74a26.44,26.44,0,0,0,.47-5.3c0-1.36-.35-5.17-.73-9.19-.53-5.81-1.14-12.39-.94-14.2.33-3,12.49-77.84,13-81a.51.51,0,0,1,.56-.42l12.91,1.89c-1-3.48-5.47-18.27-10.35-23.73-5.56-6.2-20.88-6-26.43-3.54-3.22,1.43-6.82,8.29-5.7,32.85.66,14.51,2.32,77.71,2.33,78.35a.45.45,0,0,1,0,.2c-.06.16-6.36,15.4-8.34,19.37-.53,1-1,1.92-1.44,2.62A9.82,9.82,0,0,0,348.15,458.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.53,459h26.74a24.37,24.37,0,0,0,.59-5.8c0-3.33-2-20.33-1.67-23.33,0-.29.17-1.34.41-3H358.35c.11,4.56.17,7.33.17,7.33s-6.33,15.33-8.33,19.33C348.87,456.18,347.6,458,347.53,459Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.27,459.5H347.53a.52.52,0,0,1-.37-.16A.51.51,0,0,1,347,459a9.77,9.77,0,0,1,1.4-3.2c.4-.72.85-1.54,1.31-2.46,1.89-3.77,7.74-17.89,8.28-19.2l-.17-7.23a.48.48,0,0,1,.15-.36.47.47,0,0,1,.35-.15H373.6a.5.5,0,0,1,.49.57c-.23,1.65-.37,2.7-.4,3-.19,1.71.41,8.23.94,14,.39,4.23.73,7.88.73,9.29a25.08,25.08,0,0,1-.61,5.94A.5.5,0,0,1,374.27,459.5Zm-26.1-1h25.72a26.52,26.52,0,0,0,.47-5.3c0-1.36-.35-5.17-.73-9.19-.53-5.81-1.14-12.39-.94-14.2,0-.25.14-1.1.33-2.44H358.87l.15,6.82a.45.45,0,0,1,0,.2c-.06.16-6.36,15.4-8.34,19.37-.47.93-.93,1.76-1.33,2.49A19.89,19.89,0,0,0,348.17,458.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.27,459a24.37,24.37,0,0,0,.59-5.8c0-1.77-.57-7.42-1.05-12.77l-2.29-.23s-.66-5.67-5.33-7a9,9,0,0,0-7.67,1s-6.33,15.33-8.33,19.33c-1.32,2.65-2.59,4.48-2.66,5.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.27,459.5H347.53a.52.52,0,0,1-.37-.16A.51.51,0,0,1,347,459a9.77,9.77,0,0,1,1.4-3.2c.4-.72.85-1.54,1.31-2.46,2-3.94,8.26-19.15,8.32-19.3a.45.45,0,0,1,.16-.2,9.35,9.35,0,0,1,8.11-1.09c4.24,1.21,5.37,5.65,5.63,7l1.9.19a.51.51,0,0,1,.45.45l.32,3.57c.39,4.21.73,7.85.73,9.25a25.08,25.08,0,0,1-.61,5.94A.5.5,0,0,1,374.27,459.5Zm-26.1-1h25.72a26.52,26.52,0,0,0,.47-5.3c0-1.36-.35-5.15-.72-9.16l-.29-3.15-1.88-.19a.49.49,0,0,1-.44-.44c0-.05-.69-5.35-5-6.58a8.59,8.59,0,0,0-7.12.85c-.63,1.51-6.41,15.46-8.29,19.23-.47.93-.93,1.76-1.33,2.49A19.89,19.89,0,0,0,348.17,458.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.27,459a15.82,15.82,0,0,0,.46-2.8h-26a8.91,8.91,0,0,0-1.22,2.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.27,459.5H347.54a.52.52,0,0,1-.37-.16A.5.5,0,0,1,347,459a8.58,8.58,0,0,1,1.29-3,.48.48,0,0,1,.43-.26h26a.5.5,0,0,1,.49.55,15.81,15.81,0,0,1-.47,2.89A.5.5,0,0,1,374.27,459.5Zm-26.1-1h25.72a16.61,16.61,0,0,0,.29-1.8H349.06A13.9,13.9,0,0,0,348.17,458.5Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M489,459.5H280a.5.5,0,0,1,0-1H489a.5.5,0,0,1,0,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270,459.5H40a.5.5,0,0,1,0-1H270a.5.5,0,0,1,0,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29,459.5H8a.5.5,0,0,1,0-1H29a.5.5,0,0,1,0,1Z",
    style: {
      fill: "#263238"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackParking);
export default __webpack_public_path__ + "static/media/feedback_parking.f0f26c7218b11b5d4bdc85590997bd57.svg";
export { ForwardRef as ReactComponent };